const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomweb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2475 1650",
    style: {
      enableBackground: "new 0 0 2475 1650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 2475,
    height: 1650
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.8533,
    y1: 812.3654,
    x2: 2304.9836,
    y2: 812.3654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M1197.054,1474.004c0,0-739.569,8.274-945.571-177.85 C45.481,1110.03,123.021,924.477,280.755,871.912c157.734-52.565,184.638-107.229,99.765-180.967 c-84.874-73.738-192.667-225.099-13.688-377.206c178.979-152.107,383.203,66.371,543.169,37.359 c159.966-29.012,96.61-126.722,306.977-59.243c210.367,67.479,163.984-128.99,333.106-146.798 c169.121-17.808,151.786,204.351,325.741,120.491c173.955-83.859,316.24-72.287,391.028,60.891 c74.787,133.178,42.3,312.552-121.771,419.452c-164.071,106.9-146.46,99.61-85.143,204.654 c61.317,105.044,116.302,450.482-162.845,499.82C1617.948,1499.704,1197.054,1474.004,1197.054,1474.004z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M743.053,1398.142c2.184-3.028,0.127-7.34-3.572-7.47 c-41.655-1.461-215.773-16.69-209.013-169.363c7.677-173.363,20.451-222.694-60.87-281.826 c-74.039-53.836-139.065-46.555-189.677-21.667c-3.531,1.736-2.275,7.175,1.658,7.145c33.857-0.26,111.443,5.409,140.13,60.195 c37.149,70.945,33.981,247.47,109.855,330.467c74.959,81.997,139.008,79.496,207.501,84.392 C740.625,1400.125,742.13,1399.422,743.053,1398.142L743.053,1398.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M183.854,819.073c-4.214-3.539-3.322-10.4,1.655-12.775c13.691-6.535,38.225-21.381,62.398-51.703 c24.241-30.407,85.702-94.799,183.161-57.59c97.46,37.209,98.71,220.834,87.327,399.349 c-11.383,178.515,174.34,277.674,174.34,277.674l49.2,30.104c0,0-182.369-64.589-230.469-208.544 c-48.1-143.954-0.918-344.628-116.675-362.166C283.672,816.588,256.53,880.116,183.854,819.073z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M128.634,1014.659c-6.117,1.271-10.284-6.022-6.149-10.812 c23.672-27.424,75.875-76.376,138.204-63.319c85.424,17.895,141.477,68.393,198.428,222.585 c55.354,149.868,229.672,230.109,278.878,240.312c2.281,0.473,3.888,2.531,3.821,4.909l0,0 c-0.088,3.104-2.943,5.368-5.905,4.676c-34.41-8.033-214.788-52.392-297.995-117.981 C350.552,1226.164,246.778,990.11,128.634,1014.659z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125602293014158141580000013757592037201068478_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.6714,
    y1: 1192.3798,
    x2: 721.2439,
    y2: 1192.3798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125602293014158141580000013757592037201068478_)"
    },
    d: "M186.583,981.471 c14.936-3.728,30.296-4.33,45.507-3.108c3.811,0.242,7.588,0.812,11.375,1.299c3.759,0.661,7.542,1.23,11.255,2.138 c7.491,1.553,14.779,3.931,21.98,6.497c28.698,10.773,54.222,29.143,74.886,51.594c20.741,22.507,36.914,48.709,50.243,76.007 c3.191,6.883,6.324,13.857,9.367,20.758c3.022,6.883,5.864,13.851,9.07,20.647l4.7,10.247l4.927,10.134 c3.214,6.794,6.81,13.386,10.241,20.066c7.186,13.177,14.657,26.205,22.902,38.731c8.258,12.51,17.089,24.634,26.664,36.143 c19.161,22.999,41.443,43.377,66.373,60.022c12.439,8.353,25.473,15.832,38.87,22.62c13.403,6.781,27.155,12.902,41.059,18.677 c27.832,11.521,56.37,21.381,84.759,31.621c0.377,0.135,0.572,0.549,0.438,0.925c-0.132,0.37-0.537,0.564-0.908,0.444 c-14.337-4.712-28.68-9.417-42.953-14.348c-14.28-4.908-28.513-9.99-42.597-15.506c-28.164-10.968-55.762-23.928-81.233-40.56 c-25.45-16.602-48.571-36.952-68.081-60.306c-9.788-11.646-18.81-23.904-27.24-36.538c-8.416-12.65-16.037-25.785-23.363-39.064 c-3.499-6.724-7.163-13.37-10.439-20.202l-5.021-10.198l-4.789-10.304c-3.267-6.839-6.162-13.835-9.241-20.753 c-3.061-6.898-6.056-13.719-9.19-20.532c-13.01-26.923-28.786-52.686-48.929-74.72c-10.105-10.941-21.093-21.084-33.179-29.77 c-12.067-8.697-25.179-15.947-39.024-21.416c-6.963-2.614-14.034-4.982-21.281-6.714c-3.597-0.98-7.268-1.624-10.921-2.366 c-3.681-0.568-7.358-1.222-11.074-1.552c-7.414-0.808-14.893-1.125-22.357-0.862c-7.434,0.294-14.976,0.95-22.157,2.569 l-0.085,0.019c-0.648,0.146-1.292-0.261-1.438-0.909C185.557,982.263,185.952,981.628,186.583,981.471z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M193.404,810.299c4.987,0.841,10.211,0.865,15.301,0.518c5.109-0.381,10.184-1.178,15.122-2.491 c9.885-2.599,19.219-7.02,27.568-12.813c4.18-2.895,8.116-6.125,11.839-9.586c3.681-3.511,7.129-7.261,10.348-11.207 c1.582-1.995,3.154-4,4.648-6.064l4.456-6.378c3.107-4.392,6.588-8.444,10.247-12.307c7.334-7.713,15.508-14.556,24.244-20.588 c8.753-5.999,18.043-11.288,27.909-15.379c9.859-4.067,20.234-7.117,30.947-8.426c5.348-0.667,10.764-0.931,16.181-0.716 c5.417,0.247,10.817,1.029,16.105,2.284c2.655,0.595,5.244,1.433,7.836,2.255c2.545,0.956,5.1,1.89,7.552,3.065 c4.922,2.285,9.685,4.943,14.07,8.111c8.879,6.202,16.505,13.958,23.071,22.368c13.039,16.98,22.016,36.423,28.791,56.291 c3.424,9.945,6.227,20.069,8.621,30.266c2.441,10.189,4.406,20.471,6.082,30.786c3.207,20.654,5.441,41.419,6.553,62.233 c0.029,0.536-0.383,0.993-0.918,1.022c-0.516,0.027-0.96-0.358-1.018-0.865c-2.288-20.664-5.032-41.264-9.051-61.6 c-2.028-10.159-4.178-20.29-6.876-30.269c-2.665-9.982-5.567-19.898-9.116-29.565c-7.056-19.294-15.989-38.044-28.54-54.005 c-3.197-3.919-6.508-7.747-10.163-11.201c-3.574-3.541-7.467-6.721-11.551-9.593c-4.059-2.918-8.44-5.333-12.951-7.412 c-2.246-1.072-4.586-1.91-6.911-2.782c-2.372-0.738-4.736-1.501-7.164-2.034c-4.835-1.141-9.778-1.805-14.755-2.079 c-4.981-0.221-9.99-0.004-14.968,0.59c-9.968,1.162-19.761,3.976-29.14,7.789c-18.758,7.683-36.043,19.363-50.451,33.716 c-3.576,3.609-6.978,7.397-9.972,11.438l-4.627,6.315c-1.607,2.11-3.282,4.176-4.995,6.203 c-3.485,4.013-7.209,7.822-11.172,11.372c-4.007,3.503-8.234,6.757-12.704,9.651c-8.982,5.72-18.942,9.894-29.298,12.155 c-10.361,2.21-21.092,2.717-31.511,0.465c-0.425-0.092-0.695-0.51-0.603-0.935c0.089-0.412,0.486-0.679,0.898-0.61 L193.404,810.299z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M296.02,948.057l684.01-11.559c27.539-0.465,49.642,23.154,48.006,51.298l-23.544,404.886 c-1.289,22.159-19.112,39.517-40.796,39.732l-657.499,6.502c-16.24,0.161-29.658-12.934-30.277-29.547l-15.731-422.574 C259.41,965.883,275.578,948.403,296.02,948.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M306.505,958.372l666.158-10.997c26.82-0.443,48.346,22.029,46.753,48.805l-22.93,385.21 c-1.255,21.082-18.613,37.597-39.731,37.801l-640.339,6.187c-15.816,0.153-28.884-12.305-29.486-28.111l-15.32-402.039 C270.85,975.331,286.597,958.701,306.505,958.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M318.963,971.649l634.34-10.472c25.539-0.422,46.037,20.977,44.52,46.474l-21.834,366.811 c-1.195,20.075-17.724,35.801-37.834,35.995l-609.754,5.891c-15.061,0.145-27.505-11.718-28.078-26.768l-14.589-382.836 C285.011,987.799,300.006,971.962,318.963,971.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M974.201,947.056l-668.949,11.043c-19.991,0.33-35.804,17.03-35.042,37.01l1.08,28.34h748.23 l1.63-27.384C1022.75,969.177,1001.133,946.611,974.201,947.056z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M326.287,971.798c0,3.323-2.694,6.016-6.017,6.016c-3.323,0-6.017-2.694-6.017-6.016 c0-3.323,2.694-6.017,6.017-6.017C323.594,965.781,326.287,968.475,326.287,971.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M326.287,989.428c0,3.323-2.694,6.017-6.017,6.017c-3.323,0-6.017-2.694-6.017-6.017 c0-3.323,2.694-6.016,6.017-6.016C323.594,983.411,326.287,986.105,326.287,989.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M326.287,1007.057c0,3.323-2.694,6.017-6.017,6.017c-3.323,0-6.017-2.694-6.017-6.017 s2.694-6.016,6.017-6.016C323.594,1001.041,326.287,1003.735,326.287,1007.057z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165919468247177443100000007005467214799539362_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.3438,
    y1: 1174.282,
    x2: 528.0525,
    y2: 1174.282
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000165919468247177443100000007005467214799539362_)"
    },
    cx: 432.698,
    cy: 1174.282,
    r: 95.354
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7D97F4"
    },
    cx: 432.698,
    cy: 1174.282,
    r: 21.023
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M483.81,1208.718c-11.023,16.183-29.595,26.813-50.652,26.813 c-33.827,0-61.249-27.422-61.249-61.249c0-33.827,27.422-61.249,61.249-61.249c1.036,0,2.066,0.027,3.09,0.078v-15.526 c-1.025-0.041-2.054-0.067-3.09-0.067c-42.396,0-76.764,34.368-76.764,76.764c0,42.396,34.368,76.764,76.764,76.764 c26.227,0,49.378-13.156,63.224-33.225L483.81,1208.718z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003072814333437284210000003200453739612245654_",
    gradientUnits: "userSpaceOnUse",
    x1: 618.0259,
    y1: 1111.3879,
    x2: 575.3168,
    y2: 1152.949,
    gradientTransform: "matrix(1 0.0066 -0.0066 1 -0.8808 -35.7664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003072814333437284210000003200453739612245654_)"
    },
    d: "M600.903,1101.764 c-0.051,7.716-6.348,13.931-14.064,13.88c-7.717-0.051-13.931-6.348-13.88-14.064c0.051-7.717,6.348-13.931,14.064-13.88 C594.74,1087.751,600.954,1094.047,600.903,1101.764z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109746572803324650990000013402150563917342122_",
    gradientUnits: "userSpaceOnUse",
    x1: 605.5046,
    y1: 1118.0831,
    x2: 550.0877,
    y2: 1201.8022,
    gradientTransform: "matrix(1 0.0066 -0.0066 1 -0.8808 -35.7664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109746572803324650990000013402150563917342122_)"
    },
    d: "M600.439,1101.761 c-0.049,7.46-6.136,13.468-13.596,13.418c-7.46-0.049-13.468-6.136-13.418-13.596c0.049-7.46,6.137-13.468,13.596-13.418 C594.48,1088.214,600.488,1094.301,600.439,1101.761z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129199964534379992460000003968059097566460551_",
    gradientUnits: "userSpaceOnUse",
    x1: 574.4843,
    y1: 1100.1456,
    x2: 574.6758,
    y2: 1100.1456
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129199964534379992460000003968059097566460551_)"
    },
    d: "M574.484,1100.928 c0.031-0.531,0.096-1.054,0.191-1.565L574.484,1100.928z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150078106773487401350000003586156609888594609_",
    gradientUnits: "userSpaceOnUse",
    x1: 575.8304,
    y1: 1092.5952,
    x2: 589.2617,
    y2: 1092.5952
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150078106773487401350000003586156609888594609_)"
    },
    d: "M575.83,1095.988 c2.08-4.054,6.315-6.817,11.183-6.784c0.768,0.005,1.519,0.08,2.248,0.217L575.83,1095.988z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098927021035264309250000001942878193620627845_",
    gradientUnits: "userSpaceOnUse",
    x1: 618.5848,
    y1: 1196.0853,
    x2: 575.8758,
    y2: 1237.6464,
    gradientTransform: "matrix(1 0.0066 -0.0066 1 -0.8808 -35.7664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098927021035264309250000001942878193620627845_)"
    },
    d: "M600.903,1186.465 c-0.051,7.716-6.348,13.931-14.064,13.88c-7.717-0.051-13.931-6.348-13.88-14.064c0.051-7.717,6.348-13.931,14.064-13.88 C594.74,1172.452,600.954,1178.749,600.903,1186.465z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095307127949686441380000006176757148422195592_",
    gradientUnits: "userSpaceOnUse",
    x1: 606.0637,
    y1: 1202.7805,
    x2: 550.6465,
    y2: 1286.5,
    gradientTransform: "matrix(1 0.0066 -0.0066 1 -0.8808 -35.7664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095307127949686441380000006176757148422195592_)"
    },
    d: "M600.439,1186.462 c-0.049,7.46-6.136,13.467-13.596,13.418c-7.46-0.049-13.468-6.136-13.418-13.596c0.049-7.46,6.137-13.468,13.596-13.418 C594.48,1172.915,600.488,1179.002,600.439,1186.462z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074441546200490521720000009679252338522730145_",
    gradientUnits: "userSpaceOnUse",
    x1: 574.4843,
    y1: 1184.8468,
    x2: 574.6758,
    y2: 1184.8468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074441546200490521720000009679252338522730145_)"
    },
    d: "M574.484,1185.629 c0.031-0.531,0.096-1.054,0.191-1.565L574.484,1185.629z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092435349384476063740000014733233362869916341_",
    gradientUnits: "userSpaceOnUse",
    x1: 575.8304,
    y1: 1177.2963,
    x2: 589.2617,
    y2: 1177.2963
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092435349384476063740000014733233362869916341_)"
    },
    d: "M575.83,1180.689 c2.08-4.054,6.315-6.816,11.183-6.785c0.768,0.005,1.519,0.08,2.248,0.217L575.83,1180.689z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005946774946586302860000000805138105772530330_",
    gradientUnits: "userSpaceOnUse",
    x1: 619.1438,
    y1: 1280.783,
    x2: 576.4348,
    y2: 1322.3439,
    gradientTransform: "matrix(1 0.0066 -0.0066 1 -0.8808 -35.7664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005946774946586302860000000805138105772530330_)"
    },
    d: "M600.903,1271.166 c-0.051,7.716-6.348,13.93-14.064,13.88c-7.717-0.051-13.931-6.348-13.88-14.064c0.051-7.716,6.348-13.931,14.064-13.88 C594.74,1257.153,600.954,1263.45,600.903,1271.166z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157998941987186975060000011086613754227896454_",
    gradientUnits: "userSpaceOnUse",
    x1: 606.6226,
    y1: 1287.4781,
    x2: 551.2057,
    y2: 1371.1971,
    gradientTransform: "matrix(1 0.0066 -0.0066 1 -0.8808 -35.7664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000157998941987186975060000011086613754227896454_)"
    },
    cx: 586.931,
    cy: 1271.074,
    r: 13.508
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177467279830990854270000000731069516255828620_",
    gradientUnits: "userSpaceOnUse",
    x1: 574.4843,
    y1: 1269.548,
    x2: 574.6758,
    y2: 1269.548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177467279830990854270000000731069516255828620_)"
    },
    d: "M574.484,1270.331 c0.031-0.531,0.096-1.054,0.191-1.565L574.484,1270.331z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106834084964309630320000007970107774142778496_",
    gradientUnits: "userSpaceOnUse",
    x1: 575.8304,
    y1: 1261.9974,
    x2: 589.2617,
    y2: 1261.9974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106834084964309630320000007970107774142778496_)"
    },
    d: "M575.83,1265.39 c2.08-4.054,6.315-6.817,11.183-6.784c0.768,0.005,1.519,0.08,2.248,0.217L575.83,1265.39z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "#FFFFFF"
    },
    d: "M622.398,1101.037l0.064,2.38c0.174,6.442,4.198,11.553,9.115,11.578l271.866,0.567 c5.077,0.026,9.201-5.369,9.192-12.024l0,0c-0.009-6.527-3.994-11.849-8.972-11.981l-271.931-2.947 C626.477,1088.471,622.211,1094.15,622.398,1101.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "#FFFFFF"
    },
    d: "M622.398,1185.325l0.064,2.38c0.174,6.442,4.198,11.554,9.115,11.579l271.866,0.567 c5.077,0.026,9.201-5.368,9.192-12.024l0,0c-0.009-6.527-3.994-11.849-8.972-11.981l-271.931-2.947 C626.477,1172.759,622.211,1178.438,622.398,1185.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "#FFFFFF"
    },
    d: "M622.398,1269.613l0.064,2.38c0.174,6.442,4.198,11.554,9.115,11.579l271.866,0.567 c5.077,0.026,9.201-5.368,9.192-12.024l0,0c-0.009-6.527-3.994-11.849-8.972-11.981l-271.931-2.947 C626.477,1257.047,622.211,1262.725,622.398,1269.613z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M929.322,1336.053l-583.623,10.354c-10.25,0.182-17.965,9.394-16.347,19.516l2.574,16.099 c1.311,8.204,8.404,14.229,16.712,14.196l578.479-2.273c8.595-0.034,15.788-6.528,16.696-15.075l2.571-24.179 C947.455,1344.612,939.455,1335.873,929.322,1336.053z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146471773285966346840000018048912539887256243_",
    gradientUnits: "userSpaceOnUse",
    x1: 640.35,
    y1: 1226.0527,
    x2: 635.5748,
    y2: 1238.4952,
    gradientTransform: "matrix(-0.9818 -0.1901 -0.1901 0.9818 1660.3458 162.9533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146471773285966346840000018048912539887256243_)"
    },
    d: "M802.107,1256.54 c-2.296-2.259-4.712-4.778-7.387-7.697l-2.524-2.752l3.57,1.095c3,0.92,6.063,1.699,9.101,2.32l1.137,0.232l-2.752,7.931 L802.107,1256.54z M798.698,1250.139c1.281,1.359,2.506,2.625,3.692,3.819l0.937-2.698 C801.783,1250.924,800.237,1250.55,798.698,1250.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M380.221,408.33c28.008,43.874,73.894,77.069,119.577,104.201 c59.744,35.483,124.709,67.098,167.304,121.998c44.492,57.346,58.415,132.837,60.176,205.398 c1.761,72.56-7.2,145.236-2.216,217.646c4.74,68.868,24.035,139.982,70.406,190.583c-45.118-13.843-76.65-58.795-88.236-105.237 c-12.358-49.536-6.863-101.484-4.527-152.485c2.336-51.001,0.842-104.521-23.582-149.354 c-47.922-87.969-164.202-112.089-233.154-184.757c-35.671-37.594-57.058-86.899-68.814-137.372 c-8.011-34.396-11.835-69.536-14.311-104.812C362.159,404.367,374.949,400.072,380.221,408.33z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M553.912,704.586l-4.217-362.908c-0.237-20.394,17.86-36.14,38.025-33.086l98.492,14.914 c16.17,2.449,28.123,16.348,28.123,32.702v330.88L553.912,704.586z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2383.81,1072.665c6.492,1.272,10.815-6.5,6.38-11.522 c-25.395-28.75-81.258-79.949-147.092-65.371c-90.228,19.979-148.965,74.123-207.4,238.065 c-56.796,159.346-240.389,246.409-292.364,257.806c-2.41,0.528-4.086,2.727-3.986,5.244l0,0c0.131,3.285,3.181,5.647,6.309,4.88 c36.335-8.921,226.778-58.067,314.083-128.516C2151.405,1299.283,2258.426,1048.101,2383.81,1072.665z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041254920249679603350000010925826790236436660_",
    gradientUnits: "userSpaceOnUse",
    x1: 1760.9528,
    y1: 1264.8417,
    x2: 2323.2917,
    y2: 1264.8417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041254920249679603350000010925826790236436660_)"
    },
    d: "M2321.337,1040.941 c-7.59-1.592-15.583-2.164-23.438-2.363c-7.889-0.167-15.786,0.279-23.605,1.242c-3.92,0.403-7.795,1.149-11.674,1.803 c-3.848,0.838-7.715,1.573-11.499,2.661c-7.625,1.94-15.061,4.531-22.376,7.388c-14.541,5.964-28.284,13.797-40.904,23.145 c-12.643,9.334-24.097,20.2-34.637,31.875c-20.997,23.521-37.347,50.941-50.763,79.563c-3.229,7.244-6.303,14.486-9.463,21.826 c-3.182,7.366-6.169,14.812-9.551,22.096l-4.955,10.974l-5.202,10.865c-3.392,7.278-7.2,14.364-10.83,21.531 c-7.611,14.16-15.537,28.171-24.314,41.679c-8.791,13.492-18.215,26.594-28.46,39.058 c-20.412,25.001-44.735,46.824-71.536,64.705c-26.832,17.904-55.931,31.956-85.658,43.849 c-29.748,11.926-60.032,22.211-90.304,32.454c-0.482,0.163-1.005-0.095-1.168-0.577c-0.16-0.472,0.089-0.984,0.551-1.159 c29.901-11.271,59.981-22.101,89.271-34.692c29.247-12.602,57.915-26.704,83.987-44.767 c26.138-17.928,49.393-39.776,69.366-64.319c9.976-12.286,19.16-25.215,27.733-38.547c8.56-13.348,16.298-27.221,23.731-41.249 c3.546-7.109,7.265-14.126,10.58-21.354l5.084-10.782l4.843-10.9c3.306-7.23,6.225-14.639,9.336-21.959 c3.137-7.344,6.385-14.781,9.686-22.115c13.816-29.104,30.666-57.089,52.417-81.221c21.671-24.073,48.6-43.833,78.95-55.578 c7.619-2.799,15.33-5.406,23.269-7.122c3.933-0.999,7.944-1.639,11.927-2.375c4.015-0.554,8.018-1.194,12.061-1.487 c16.136-1.441,32.422-0.951,48.327,2.889c0.822,0.198,1.328,1.026,1.129,1.848c-0.195,0.806-0.994,1.308-1.801,1.14 L2321.337,1040.941z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050642768887846434220000003453507614400249516_",
    gradientUnits: "userSpaceOnUse",
    x1: 1673.5283,
    y1: 1483.3077,
    x2: 1668.7531,
    y2: 1495.7505,
    gradientTransform: "matrix(0.9818 -0.1901 0.1901 0.9818 -163.7041 162.9533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050642768887846434220000003453507614400249516_)"
    },
    d: "M1756.668,1313.835l-2.752-7.931 l1.137-0.232c3.039-0.621,6.102-1.4,9.102-2.32l3.57-1.095l-2.524,2.752c-2.675,2.919-5.091,5.438-7.387,7.697L1756.668,1313.835 z M1756.594,1307.425l0.937,2.698c1.187-1.194,2.412-2.46,3.693-3.819C1759.684,1306.716,1758.137,1307.09,1756.594,1307.425z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181082502725288786130000015207181092119754369_",
    gradientUnits: "userSpaceOnUse",
    x1: 1912.0763,
    y1: 1189.5953,
    x2: 1908.9343,
    y2: 1197.7823,
    gradientTransform: "matrix(0.9931 0.1175 -0.1175 0.9931 132.9765 -83.2971)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181082502725288786130000015207181092119754369_)"
    },
    d: "M1886.609,1329.789l-0.138-5.521 l0.759,0.082c2.029,0.219,4.105,0.344,6.169,0.367l2.457,0.028l-2.132,1.22c-2.261,1.294-4.28,2.39-6.171,3.347L1886.609,1329.789 z M1887.845,1325.756l0.047,1.879c0.983-0.511,2.004-1.059,3.078-1.655C1889.924,1325.93,1888.88,1325.855,1887.845,1325.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2321.703,882.058c-26.334,21.897-61.737,33.522-95.8,41.389 c-44.547,10.288-91.593,17.105-129.277,42.995c-39.362,27.043-63.193,71.575-78.814,116.704 c-15.622,45.129-24.546,92.475-42.158,136.865c-16.75,42.218-43.073,82.932-82.262,105.372 c31.05,0.35,59.808-21.517,76.362-48.309c17.657-28.577,24.607-62.238,33.347-94.673c8.74-32.435,20.385-65.683,44.664-88.898 c47.638-45.551,125.349-37.405,183.108-69.158c29.881-16.427,53.151-43.053,70.618-72.338 c11.903-19.957,21.331-41.218,29.941-62.833C2333.816,883.188,2326.659,877.937,2321.703,882.058z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2104.045,843.622c-8.668-14.314-19.393-27.203-30.627-39.648 c-3.453-3.826-9.785-1.286-9.683,3.866c0.428,21.569-9.799,43.485-23.118,61.137c-16.963,22.479-38.937,40.936-54.833,64.182 c-32.715,47.842-35.81,110.064-28.795,167.596c7.014,57.532,22.957,114.085,24.161,172.03 c0.574,27.626-2.409,55.952-14.366,80.863c-11.742,24.464-33.222,45.291-59.607,51.387c-0.763,0.176-1.202,0.975-0.924,1.707l0,0 c0.165,0.434,0.551,0.752,1.01,0.823c33.652,5.216,66.51-20.234,79.702-51.72c13.289-31.717,10.773-67.729,5.03-101.635 c-5.742-33.906-14.512-67.751-13-102.107c1.51-34.309,13.592-68.08,34.186-95.562c18.746-25.016,43.869-44.391,65.688-66.777 c21.819-22.386,41.125-49.778,43.32-80.96C2123.798,885.946,2115.915,863.223,2104.045,843.622z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113332194473827040020000007382139557343048086_",
    gradientUnits: "userSpaceOnUse",
    x1: 1967.8451,
    y1: 987.0048,
    x2: 2075.4084,
    y2: 987.0048
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113332194473827040020000007382139557343048086_)"
    },
    d: "M2075.408,851.858 c-0.128,3.209-0.458,6.317-1.01,9.421c-0.514,3.103-1.159,6.182-1.921,9.232c-1.513,6.101-3.442,12.108-5.811,17.933 c-1.087,2.956-2.446,5.792-3.704,8.677c-0.609,1.453-1.359,2.836-2.053,4.248l-2.125,4.216c-1.52,2.754-3.118,5.464-4.676,8.199 l-5.09,7.948c-1.799,2.579-3.676,5.104-5.511,7.658c-0.894,1.296-1.923,2.487-2.899,3.719l-2.959,3.672 c-1.95,2.489-4.005,4.793-6.022,7.165c-2.031,2.356-4.045,4.72-6.039,7.092c-8.003,9.477-15.83,19.065-22.73,29.267 c-6.885,10.206-12.727,21.067-17.329,32.453c-2.465,5.634-4.202,11.543-6.114,17.389c-1.467,5.978-3.206,11.898-4.17,18.002 c-2.469,12.099-3.458,24.46-4.374,36.804c-0.264,6.187-0.403,12.387-0.578,18.586l0.19,18.619l0,0.017 c0.005,0.49-0.388,0.891-0.878,0.896c-0.474,0.005-0.865-0.365-0.895-0.832c-1.535-24.849-1.314-50.003,3.008-74.735 c3.88-24.783,13.459-48.78,27.485-69.652c6.992-10.453,14.876-20.206,22.867-29.772c3.958-4.808,8.111-9.492,11.991-14.273 l2.914-3.576c0.961-1.2,1.977-2.359,2.856-3.621c1.807-2.486,3.656-4.945,5.43-7.454l5.1-7.682 c1.563-2.644,3.171-5.266,4.702-7.93c1.423-2.721,2.991-5.373,4.335-8.137c1.319-2.775,2.745-5.507,3.899-8.357 c2.524-5.615,4.522-11.441,6.381-17.306c0.907-2.941,1.7-5.918,2.367-8.92c0.678-2.991,1.255-6.051,1.589-9.043l0.006-0.058 c0.054-0.486,0.493-0.837,0.979-0.782C2075.085,850.994,2075.425,851.399,2075.408,851.858z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154416433862167040470000016875744760137050504_",
    gradientUnits: "userSpaceOnUse",
    x1: 1062.4344,
    y1: 1351.5825,
    x2: 1374.5359,
    y2: 415.2756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154416433862167040470000016875744760137050504_)"
    },
    d: "M1868.306,1385.549 c0,13.427-10.997,24.414-24.437,24.414H522.403c-13.441,0-24.437-10.986-24.437-24.414l-10.996-759.41 c0-13.427,15.82-39.641,44.813-37.672l1291.482-33.417c16.864-0.436,33.169,6.055,45.111,17.958 c11.942,11.903,18.476,28.178,18.078,45.026L1868.306,1385.549z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109748538602267558030000009090092469925893540_",
    gradientUnits: "userSpaceOnUse",
    x1: 1217.5286,
    y1: 725.8217,
    x2: 1358.6342,
    y2: -446.1458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109748538602267558030000009090092469925893540_)"
    },
    d: "M1844.18,1362.127 c0,12.716-10.404,23.119-23.119,23.119H554.271c-12.716,0-23.119-10.404-23.119-23.119l-10.376-689.399 c1.222-41.486,37.594-56.397,59.642-55.516l1237.804-33.208c11.848-0.318,23.306,4.243,31.694,12.617 c8.388,8.373,12.969,19.824,12.672,31.672L1844.18,1362.127z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M544.842,1032.225c-0.545,0-0.991-0.438-1-0.985l-0.821-55.909 c-0.008-0.552,0.433-1.007,0.985-1.015c0.005,0,0.01,0,0.015,0c0.545,0,0.991,0.438,1,0.985l0.821,55.909 c0.008,0.552-0.433,1.007-0.985,1.015C544.852,1032.225,544.848,1032.225,544.842,1032.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M542.83,895.219c-0.545,0-0.991-0.439-0.999-0.985l-3.145-214.132 c0.064-14.04,4.38-25.255,12.828-33.35c15.427-14.783,39.629-14.034,40.648-13.999l395.331-10.607 c0.572,0.033,1.012,0.422,1.026,0.974c0.015,0.552-0.42,1.011-0.973,1.026l-395.382,10.607 c-1.067-0.045-24.446-0.76-39.268,13.442c-8.042,7.706-12.15,18.438-12.212,31.896l3.145,214.112 c0.008,0.552-0.433,1.007-0.985,1.015C542.84,895.219,542.835,895.219,542.83,895.219z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114789897834818979480000004327521915355538591_",
    gradientUnits: "userSpaceOnUse",
    x1: 1526.9255,
    y1: 475.274,
    x2: 1355.9087,
    y2: 748.3013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114789897834818979480000004327521915355538591_)"
    },
    d: "M586.962,1323.883 c1.326-56.979,0.833-561.549-2.437-605.126c-3.269-43.577,64.599-51.75,168.797-56.654 c104.198-4.904,983.358-24.32,1005.994-26.155c50.882-4.126,61.414,71.927,56.323,237.031 c-3.824,124.041-10.163,328.378-13.079,422.347c-0.868,27.98-23.738,50.18-51.731,50.257 c-211.562,0.581-1022.416,2.905-1076.396,4.513C612.315,1351.946,586.436,1346.476,586.962,1323.883z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150787584824493212500000012260493187937346490_",
    gradientUnits: "userSpaceOnUse",
    x1: 1442.532,
    y1: 1441.5283,
    x2: 209.6185,
    y2: 1432.0686
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150787584824493212500000012260493187937346490_)"
    },
    d: "M1942.146,1473.003H450.916 c-18.349,0-33.362-15.013-33.362-33.362l0,0c0-18.349,15.013-33.362,33.362-33.362h1491.231 c18.349,0,33.362,15.013,33.362,33.362l0,0C1975.509,1457.99,1960.496,1473.003,1942.146,1473.003z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2144.836,762.026c-0.342,0-0.668-0.198-0.816-0.531c-0.2-0.45,0.003-0.977,0.454-1.177 c1.082-0.48,2.159-0.97,3.23-1.47c0.447-0.207,0.977-0.016,1.186,0.431c0.208,0.446,0.015,0.977-0.431,1.186 c-1.082,0.505-2.169,0.999-3.262,1.485C2145.08,762.002,2144.957,762.026,2144.836,762.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2073.344,778c-0.483,0-0.879-0.385-0.891-0.87c-0.012-0.492,0.377-0.902,0.87-0.914 c2.325-0.057,4.675-0.159,6.982-0.301c0.5-0.009,0.915,0.345,0.945,0.836c0.031,0.491-0.344,0.915-0.835,0.945 c-2.33,0.144-4.701,0.246-7.048,0.304C2073.359,778,2073.352,778,2073.344,778z M2061.938,777.931 c-0.011,0-0.021,0-0.032-0.001c-2.339-0.084-4.708-0.215-7.042-0.388c-0.491-0.036-0.86-0.463-0.824-0.955 c0.036-0.491,0.445-0.859,0.955-0.824c2.312,0.171,4.659,0.3,6.975,0.384c0.493,0.017,0.877,0.431,0.859,0.923 C2062.812,777.553,2062.416,777.931,2061.938,777.931z M2091.72,776.658c-0.444,0-0.829-0.332-0.884-0.784 c-0.06-0.489,0.288-0.934,0.778-0.993c2.304-0.281,4.632-0.61,6.92-0.975c0.482-0.077,0.944,0.254,1.021,0.741 c0.078,0.486-0.253,0.943-0.74,1.021c-2.309,0.368-4.659,0.699-6.985,0.984C2091.793,776.657,2091.756,776.658,2091.72,776.658 z M2043.587,776.357c-0.04,0-0.081-0.003-0.121-0.008c-2.326-0.316-4.671-0.68-6.97-1.082c-0.486-0.085-0.81-0.547-0.725-1.032 c0.084-0.485,0.547-0.802,1.032-0.726c2.278,0.398,4.601,0.759,6.904,1.071c0.488,0.067,0.83,0.517,0.764,1.004 C2044.409,776.033,2044.026,776.357,2043.587,776.357z M2109.878,773.539c-0.409,0-0.777-0.282-0.87-0.698 c-0.107-0.481,0.196-0.958,0.677-1.065c2.257-0.504,4.542-1.058,6.79-1.647c0.476-0.125,0.964,0.159,1.089,0.636 c0.125,0.477-0.16,0.964-0.636,1.089c-2.27,0.596-4.576,1.156-6.855,1.664C2110.007,773.532,2109.942,773.539,2109.878,773.539 z M2025.479,772.976c-0.069,0-0.138-0.008-0.208-0.024c-2.283-0.544-4.587-1.14-6.848-1.772 c-0.474-0.132-0.752-0.625-0.619-1.099c0.132-0.475,0.625-0.753,1.099-0.619c2.239,0.625,4.52,1.215,6.781,1.755 c0.479,0.114,0.775,0.595,0.661,1.075C2026.249,772.701,2025.883,772.976,2025.479,772.976z M2127.641,768.649 c-0.375,0-0.724-0.238-0.848-0.613c-0.154-0.468,0.101-0.972,0.569-1.126c2.189-0.72,4.408-1.497,6.594-2.31 c0.464-0.173,0.976,0.065,1.147,0.525c0.172,0.462-0.064,0.976-0.525,1.147c-2.208,0.821-4.448,1.605-6.658,2.332 C2127.827,768.635,2127.734,768.649,2127.641,768.649z M2007.762,767.806c-0.097,0-0.195-0.016-0.292-0.05 c-2.227-0.772-4.458-1.592-6.633-2.44c-0.459-0.179-0.686-0.696-0.507-1.155c0.179-0.46,0.697-0.685,1.155-0.507 c2.154,0.839,4.364,1.653,6.569,2.417c0.466,0.161,0.712,0.669,0.551,1.134 C2008.477,767.575,2008.132,767.806,2007.762,767.806z M1990.654,760.911c-0.125,0-0.253-0.026-0.374-0.082 c-2.139-0.988-4.277-2.025-6.355-3.081c-0.439-0.224-0.614-0.76-0.391-1.2c0.224-0.44,0.761-0.612,1.2-0.391 c2.058,1.046,4.176,2.073,6.295,3.052c0.447,0.206,0.642,0.737,0.436,1.184 C1991.313,760.719,1990.991,760.911,1990.654,760.911z M1974.315,752.366c-0.153,0-0.309-0.039-0.451-0.123 c-2.021-1.186-4.046-2.428-6.019-3.688c-0.415-0.266-0.537-0.817-0.271-1.232c0.266-0.416,0.817-0.536,1.232-0.272 c1.954,1.249,3.96,2.479,5.961,3.654c0.425,0.249,0.567,0.796,0.318,1.221C1974.919,752.208,1974.621,752.366,1974.315,752.366 z M1958.9,742.264c-0.182,0-0.366-0.056-0.524-0.171c-1.889-1.376-3.782-2.808-5.626-4.257 c-0.387-0.305-0.454-0.865-0.15-1.253c0.305-0.388,0.865-0.455,1.253-0.15c1.827,1.437,3.701,2.855,5.573,4.217 c0.398,0.29,0.486,0.848,0.196,1.247C1959.448,742.137,1959.176,742.264,1958.9,742.264z M1944.554,730.707 c-0.211,0-0.422-0.074-0.592-0.226c-1.755-1.56-3.497-3.17-5.181-4.785c-0.355-0.341-0.367-0.906-0.026-1.261 c0.341-0.354,0.906-0.367,1.261-0.026c1.667,1.599,3.394,3.194,5.131,4.74c0.368,0.328,0.401,0.891,0.074,1.26 C1945.045,730.606,1944.8,730.707,1944.554,730.707z M1931.41,717.806c-0.24,0-0.48-0.097-0.656-0.287 c-1.59-1.721-3.166-3.493-4.685-5.265c-0.321-0.374-0.277-0.937,0.097-1.258c0.373-0.321,0.937-0.279,1.258,0.098 c1.504,1.755,3.066,3.51,4.641,5.215c0.335,0.362,0.312,0.927-0.05,1.261C1931.843,717.727,1931.626,717.806,1931.41,717.806z  M1919.596,703.688c-0.27,0-0.537-0.122-0.712-0.354c-1.415-1.87-2.809-3.786-4.144-5.696c-0.282-0.404-0.183-0.96,0.22-1.242 c0.403-0.282,0.96-0.184,1.242,0.219c1.322,1.892,2.703,3.79,4.104,5.642c0.297,0.393,0.22,0.952-0.173,1.25 C1919.972,703.628,1919.783,703.688,1919.596,703.688z M1909.229,688.485c-0.3,0-0.593-0.152-0.762-0.426 c-1.224-2.001-2.422-4.044-3.561-6.072c-0.241-0.43-0.088-0.973,0.342-1.214c0.431-0.241,0.974-0.088,1.214,0.341 c1.127,2.009,2.313,4.032,3.526,6.013c0.257,0.421,0.125,0.97-0.295,1.227C1909.549,688.442,1909.388,688.485,1909.229,688.485 z M1900.416,672.345c-0.331,0-0.65-0.185-0.804-0.503c-1.02-2.11-2.012-4.265-2.949-6.408c-0.198-0.451,0.008-0.977,0.46-1.174 c0.452-0.199,0.977,0.008,1.175,0.46c0.929,2.121,1.911,4.257,2.922,6.346c0.214,0.443,0.029,0.977-0.415,1.192 C1900.678,672.316,1900.546,672.345,1900.416,672.345z M1893.23,655.383c-0.364,0-0.705-0.224-0.838-0.585 c-0.808-2.206-1.582-4.449-2.3-6.668c-0.152-0.469,0.105-0.971,0.574-1.123c0.47-0.154,0.972,0.105,1.123,0.574 c0.712,2.197,1.478,4.418,2.278,6.603c0.169,0.463-0.068,0.975-0.531,1.145C1893.436,655.365,1893.332,655.383,1893.23,655.383 z M1887.76,637.795c-0.398,0-0.76-0.268-0.863-0.67c-0.584-2.266-1.132-4.575-1.63-6.861c-0.105-0.482,0.2-0.956,0.682-1.062 c0.481-0.11,0.956,0.201,1.062,0.682c0.494,2.265,1.037,4.552,1.614,6.797c0.123,0.477-0.164,0.964-0.641,1.086 C1887.909,637.786,1887.834,637.795,1887.76,637.795z M1884.05,619.753c-0.432,0-0.812-0.314-0.88-0.755 c-0.357-2.306-0.676-4.656-0.95-6.988c-0.057-0.489,0.293-0.932,0.782-0.99c0.477-0.062,0.932,0.293,0.99,0.782 c0.271,2.309,0.588,4.639,0.941,6.922c0.075,0.487-0.258,0.943-0.745,1.018C1884.142,619.75,1884.096,619.753,1884.05,619.753z  M1882.117,601.43c-0.469,0-0.863-0.367-0.89-0.841c-0.133-2.342-0.223-4.714-0.27-7.049c-0.01-0.492,0.382-0.9,0.875-0.909 c0.006,0,0.012,0,0.018,0c0.484,0,0.882,0.388,0.892,0.875c0.045,2.314,0.135,4.663,0.267,6.983 c0.028,0.492-0.348,0.913-0.84,0.941C1882.151,601.429,1882.134,601.43,1882.117,601.43z M1881.972,583.003 c-0.013,0-0.025,0-0.037-0.001c-0.492-0.02-0.875-0.436-0.855-0.928c0.096-2.336,0.237-4.706,0.421-7.044 c0.039-0.491,0.468-0.849,0.96-0.82c0.491,0.038,0.858,0.468,0.819,0.959c-0.182,2.316-0.323,4.664-0.418,6.978 C1882.843,582.628,1882.448,583.003,1881.972,583.003z M1883.635,564.649c-0.041,0-0.084-0.003-0.125-0.009 c-0.488-0.069-0.828-0.52-0.759-1.008c0.326-2.318,0.701-4.662,1.115-6.968c0.087-0.484,0.549-0.81,1.036-0.72 c0.485,0.087,0.807,0.551,0.72,1.036c-0.41,2.283-0.781,4.606-1.105,6.902C1884.455,564.327,1884.073,564.649,1883.635,564.649 z M1887.105,546.551c-0.07,0-0.141-0.008-0.212-0.025c-0.479-0.117-0.772-0.599-0.656-1.078 c0.555-2.276,1.16-4.572,1.801-6.824c0.135-0.474,0.627-0.754,1.102-0.614c0.474,0.135,0.749,0.628,0.614,1.102 c-0.634,2.23-1.234,4.504-1.783,6.758C1887.872,546.277,1887.507,546.551,1887.105,546.551z M1892.351,528.886 c-0.098,0-0.198-0.016-0.296-0.051c-0.465-0.164-0.709-0.672-0.545-1.138c0.779-2.214,1.609-4.439,2.467-6.611 c0.181-0.459,0.698-0.686,1.157-0.502c0.458,0.18,0.683,0.699,0.502,1.157c-0.85,2.152-1.672,4.355-2.444,6.548 C1893.064,528.657,1892.719,528.886,1892.351,528.886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1899.356,511.748c-0.127,0-0.255-0.027-0.378-0.084c-0.446-0.209-0.639-0.741-0.43-1.187 c0.506-1.083,1.023-2.16,1.549-3.232c0.217-0.441,0.753-0.622,1.194-0.407c0.442,0.217,0.625,0.752,0.407,1.194 c-0.521,1.061-1.033,2.128-1.534,3.201C1900.013,511.558,1899.691,511.748,1899.356,511.748z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2004.452,415.193c-0.364,0-0.705-0.224-0.838-0.585c-0.17-0.463,0.068-0.975,0.531-1.144 c1.121-0.411,2.246-0.811,3.377-1.201c0.465-0.163,0.973,0.086,1.134,0.553c0.161,0.465-0.087,0.973-0.553,1.133 c-1.12,0.386-2.235,0.782-3.344,1.188C2004.657,415.176,2004.554,415.193,2004.452,415.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2239.861,667.229c-0.122,0-0.246-0.025-0.364-0.078c-0.449-0.201-0.651-0.729-0.449-1.179 c0.973-2.173,1.916-4.393,2.802-6.6c0.184-0.457,0.702-0.68,1.16-0.495c0.457,0.184,0.679,0.703,0.495,1.16 c-0.895,2.227-1.847,4.469-2.83,6.663C2240.528,667.033,2240.202,667.229,2239.861,667.229z M2246.7,649.604 c-0.093,0-0.187-0.014-0.28-0.045c-0.468-0.154-0.722-0.659-0.567-1.127c0.746-2.256,1.459-4.56,2.119-6.85 c0.136-0.473,0.632-0.747,1.104-0.61c0.473,0.137,0.747,0.631,0.61,1.105c-0.667,2.311-1.386,4.638-2.14,6.916 C2247.423,649.367,2247.074,649.604,2246.7,649.604z M2251.717,631.378c-0.064,0-0.129-0.007-0.193-0.021 c-0.481-0.106-0.785-0.583-0.679-1.064c0.513-2.322,0.988-4.687,1.412-7.03c0.087-0.484,0.547-0.805,1.036-0.72 c0.485,0.088,0.807,0.552,0.719,1.037c-0.427,2.366-0.907,4.755-1.425,7.098 C2252.495,631.095,2252.126,631.378,2251.717,631.378z M2254.854,612.734c-0.034,0-0.069-0.002-0.104-0.006 c-0.489-0.057-0.84-0.5-0.783-0.989c0.275-2.366,0.507-4.768,0.69-7.138c0.038-0.491,0.466-0.864,0.958-0.821 c0.491,0.038,0.858,0.467,0.821,0.958c-0.185,2.393-0.419,4.818-0.697,7.206C2255.686,612.4,2255.301,612.734,2254.854,612.734 z M2256.083,593.869c-0.005,0-0.009,0-0.013,0c-0.493-0.007-0.886-0.413-0.879-0.905c0.013-0.911,0.02-1.823,0.02-2.737 c0-1.476-0.018-2.954-0.052-4.436c-0.012-0.492,0.378-0.901,0.871-0.913c0.508-0.012,0.901,0.38,0.913,0.871 c0.036,1.496,0.053,2.988,0.053,4.478c0,0.922-0.007,1.843-0.02,2.763C2256.968,593.477,2256.57,593.869,2256.083,593.869z  M2255.412,574.974c-0.459,0-0.848-0.351-0.888-0.816c-0.202-2.371-0.453-4.769-0.744-7.127 c-0.06-0.49,0.287-0.935,0.776-0.995c0.486-0.067,0.934,0.287,0.995,0.775c0.294,2.38,0.547,4.801,0.751,7.195 c0.042,0.49-0.322,0.922-0.813,0.964C2255.463,574.973,2255.438,574.974,2255.412,574.974z M2252.871,556.253 c-0.421,0-0.796-0.299-0.876-0.727c-0.439-2.345-0.929-4.707-1.454-7.019c-0.109-0.481,0.192-0.958,0.672-1.068 c0.483-0.109,0.958,0.193,1.068,0.673c0.531,2.335,1.025,4.718,1.468,7.085c0.091,0.484-0.228,0.95-0.713,1.041 C2252.98,556.247,2252.925,556.253,2252.871,556.253z M2248.461,537.878c-0.385,0-0.741-0.252-0.855-0.64 c-0.671-2.281-1.397-4.581-2.156-6.835c-0.157-0.467,0.094-0.973,0.561-1.13c0.469-0.161,0.973,0.094,1.13,0.56 c0.767,2.276,1.499,4.598,2.177,6.901c0.139,0.472-0.132,0.969-0.604,1.107 C2248.629,537.867,2248.545,537.878,2248.461,537.878z M2242.213,520.046c-0.352,0-0.685-0.209-0.826-0.554 c-0.901-2.204-1.856-4.418-2.84-6.582c-0.204-0.449-0.006-0.977,0.442-1.181c0.447-0.206,0.977-0.006,1.181,0.443 c0.993,2.184,1.958,4.42,2.868,6.644c0.186,0.456-0.032,0.977-0.488,1.164C2242.439,520.025,2242.325,520.046,2242.213,520.046 z M2234.19,502.953c-0.319,0-0.628-0.172-0.788-0.473c-1.114-2.092-2.286-4.193-3.484-6.245 c-0.248-0.425-0.104-0.971,0.321-1.22c0.425-0.247,0.972-0.105,1.22,0.321c1.209,2.072,2.393,4.193,3.518,6.305 c0.231,0.435,0.067,0.975-0.368,1.207C2234.474,502.919,2234.331,502.953,2234.19,502.953z M2224.483,486.772 c-0.287,0-0.569-0.138-0.742-0.396c-1.323-1.971-2.703-3.945-4.101-5.865c-0.29-0.398-0.202-0.956,0.196-1.247 c0.399-0.288,0.957-0.202,1.246,0.196c1.412,1.938,2.805,3.931,4.141,5.922c0.274,0.409,0.165,0.963-0.244,1.237 C2224.827,486.723,2224.654,486.772,2224.483,486.772z M2213.186,471.643c-0.257,0-0.511-0.11-0.687-0.323 c-1.525-1.84-3.097-3.665-4.674-5.426c-0.328-0.367-0.298-0.931,0.07-1.26c0.367-0.329,0.931-0.297,1.26,0.07 c1.591,1.777,3.179,3.621,4.718,5.478c0.314,0.379,0.262,0.942-0.118,1.255 C2213.588,471.576,2213.386,471.643,2213.186,471.643z M2200.42,457.722c-0.226,0-0.453-0.085-0.626-0.257 c-1.7-1.675-3.449-3.335-5.198-4.932c-0.364-0.332-0.389-0.896-0.057-1.261c0.332-0.363,0.896-0.388,1.26-0.057 c1.766,1.613,3.531,3.289,5.247,4.98c0.351,0.346,0.355,0.91,0.01,1.261C2200.88,457.633,2200.65,457.722,2200.42,457.722z  M2186.315,445.146c-0.197,0-0.394-0.064-0.559-0.198c-1.853-1.492-3.76-2.97-5.668-4.39c-0.395-0.293-0.477-0.853-0.183-1.247 c0.294-0.394,0.853-0.477,1.248-0.183c1.926,1.433,3.851,2.924,5.722,4.432c0.384,0.308,0.444,0.87,0.135,1.254 C2186.834,445.033,2186.576,445.146,2186.315,445.146z M2171.016,434.043c-0.167,0-0.336-0.047-0.486-0.145 c-1.992-1.298-4.038-2.576-6.084-3.8c-0.423-0.254-0.56-0.801-0.307-1.224c0.252-0.422,0.8-0.559,1.223-0.308 c2.065,1.236,4.131,2.526,6.141,3.837c0.413,0.269,0.529,0.822,0.26,1.234C2171.594,433.9,2171.308,434.043,2171.016,434.043z  M2154.674,424.53c-0.138,0-0.277-0.032-0.408-0.099c-2.122-1.095-4.288-2.161-6.439-3.169 c-0.446-0.209-0.638-0.74-0.429-1.186c0.21-0.445,0.741-0.638,1.187-0.429c2.171,1.018,4.358,2.093,6.5,3.199 c0.438,0.226,0.61,0.764,0.384,1.202C2155.309,424.354,2154.997,424.53,2154.674,424.53z M2137.448,416.712 c-0.108,0-0.219-0.02-0.327-0.062c-2.226-0.877-4.49-1.72-6.73-2.503c-0.465-0.163-0.71-0.672-0.548-1.137 c0.163-0.465,0.671-0.711,1.136-0.548c2.262,0.792,4.549,1.642,6.796,2.527c0.458,0.181,0.684,0.699,0.503,1.157 C2138.14,416.498,2137.804,416.712,2137.448,416.712z M2119.511,410.678c-0.08,0-0.161-0.01-0.241-0.033 c-2.296-0.645-4.637-1.253-6.955-1.807c-0.479-0.115-0.775-0.596-0.66-1.075s0.599-0.77,1.075-0.66 c2.341,0.56,4.704,1.173,7.022,1.824c0.474,0.133,0.751,0.626,0.618,1.1C2120.259,410.421,2119.901,410.678,2119.511,410.678z  M2018.99,410.533c-0.392,0-0.75-0.26-0.859-0.655c-0.131-0.475,0.148-0.966,0.622-1.097c2.319-0.64,4.679-1.242,7.013-1.789 c0.478-0.113,0.96,0.185,1.072,0.665c0.112,0.48-0.185,0.96-0.665,1.072c-2.311,0.542-4.648,1.138-6.945,1.772 C2019.149,410.523,2019.069,410.533,2018.99,410.533z M2101.062,406.501c-0.051,0-0.102-0.004-0.154-0.013 c-2.336-0.405-4.719-0.771-7.084-1.087c-0.488-0.065-0.832-0.514-0.766-1.003c0.066-0.488,0.519-0.832,1.002-0.766 c2.388,0.319,4.794,0.688,7.153,1.098c0.486,0.085,0.811,0.546,0.727,1.031 C2101.865,406.196,2101.488,406.501,2101.062,406.501z M2037.442,406.435c-0.427,0-0.805-0.308-0.878-0.743 c-0.082-0.485,0.244-0.946,0.73-1.029c2.356-0.399,4.764-0.76,7.156-1.073c0.483-0.068,0.937,0.279,1,0.768 c0.064,0.489-0.281,0.936-0.769,1c-2.37,0.31-4.755,0.668-7.09,1.065C2037.542,406.431,2037.491,406.435,2037.442,406.435z  M2082.303,404.223c-0.021,0-0.042-0.001-0.064-0.003c-2.363-0.166-4.771-0.288-7.157-0.364 c-0.492-0.015-0.879-0.427-0.864-0.919c0.015-0.492,0.44-0.9,0.919-0.863c2.409,0.076,4.84,0.199,7.227,0.368 c0.491,0.034,0.862,0.461,0.827,0.952C2083.159,403.864,2082.768,404.223,2082.303,404.223z M2056.212,404.208 c-0.465,0-0.857-0.361-0.889-0.831c-0.033-0.491,0.338-0.917,0.829-0.951c2.39-0.163,4.822-0.284,7.229-0.358 c0.486-0.044,0.904,0.372,0.919,0.863c0.015,0.493-0.371,0.904-0.864,0.92c-2.385,0.073-4.794,0.193-7.161,0.355 C2056.253,404.207,2056.232,404.208,2056.212,404.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2233.013,680.981c-0.145,0-0.293-0.036-0.429-0.111c-0.431-0.237-0.589-0.78-0.352-1.211 c0.57-1.038,1.131-2.079,1.681-3.127c0.229-0.437,0.768-0.601,1.204-0.375c0.437,0.229,0.604,0.768,0.375,1.205 c-0.556,1.058-1.122,2.11-1.697,3.156C2233.633,680.814,2233.328,680.981,2233.013,680.981z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2185.249,674.537c0.643-0.711,0.764-1.751,0.302-2.59l-13.188-23.945 c6.179-11.171,10.622-23.408,12.975-36.333l25.348-10.187c0.89-0.357,1.454-1.24,1.406-2.197l-1.641-32.749 c-0.048-0.957-0.698-1.778-1.618-2.045l-26.24-7.602c-3.633-12.626-9.276-24.357-16.542-34.854l10.728-25.144 c0.376-0.881,0.151-1.904-0.559-2.547l-24.317-21.997c-0.711-0.643-1.751-0.764-2.59-0.302l-23.945,13.187 c-11.171-6.179-23.408-10.622-36.333-12.974l-10.187-25.349c-0.357-0.889-1.239-1.454-2.196-1.406l-32.749,1.641 c-0.957,0.048-1.778,0.698-2.045,1.618l-7.602,26.24c-12.626,3.633-24.357,9.276-34.854,16.541l-25.144-10.728 c-0.881-0.376-1.904-0.151-2.547,0.559l-21.997,24.317c-0.643,0.711-0.764,1.751-0.302,2.59l13.188,23.945 c-6.18,11.171-10.622,23.408-12.975,36.333l-25.349,10.187c-0.889,0.357-1.454,1.239-1.406,2.196l1.641,32.749 c0.048,0.957,0.698,1.778,1.618,2.045l26.24,7.602c3.632,12.626,9.276,24.357,16.541,34.855l-10.728,25.143 c-0.376,0.881-0.152,1.905,0.559,2.547l24.317,21.997c0.711,0.643,1.751,0.764,2.59,0.302l23.945-13.187 c11.171,6.18,23.408,10.622,36.334,12.974l10.187,25.349c0.357,0.889,1.239,1.454,2.197,1.405l32.749-1.641 c0.957-0.048,1.778-0.697,2.045-1.618l7.602-26.24c12.625-3.633,24.357-9.276,34.854-16.541l25.144,10.728 c0.881,0.376,1.904,0.151,2.547-0.559L2185.249,674.537z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107581656607632712120000011770729101250820748_",
    gradientUnits: "userSpaceOnUse",
    x1: 2037.024,
    y1: 590.1149,
    x2: 2097.9377,
    y2: 590.1149
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107581656607632712120000011770729101250820748_)"
    },
    d: "M2067.443,620.583 c-4.913,0-9.78-1.201-14.242-3.57c-7.184-3.815-12.454-10.199-14.837-17.976c-4.919-16.055,4.14-33.12,20.195-38.04 c7.777-2.383,16.018-1.595,23.202,2.22c7.185,3.815,12.454,10.199,14.837,17.976l0,0c4.919,16.055-4.14,33.12-20.196,38.04 C2073.455,620.136,2070.44,620.583,2067.443,620.583z M2067.516,562.324c-2.735,0-5.484,0.409-8.173,1.233 c-14.644,4.487-22.907,20.052-18.421,34.696c2.174,7.095,6.98,12.918,13.533,16.397c6.554,3.479,14.07,4.197,21.164,2.024 c14.645-4.487,22.908-20.052,18.421-34.697l0,0c-2.174-7.095-6.98-12.918-13.534-16.397 C2076.437,563.42,2071.996,562.324,2067.516,562.324z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073706103368902004220000005018055251421018519_",
    gradientUnits: "userSpaceOnUse",
    x1: 1986.4662,
    y1: 589.6924,
    x2: 2147.3875,
    y2: 589.6924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073706103368902004220000005018055251421018519_)"
    },
    d: "M2066.881,670.152 c-42.535,0.001-78.161-33.488-80.313-76.435c-0.068-1.363-0.102-2.72-0.102-4.07c-0.001-42.535,33.488-78.163,76.435-80.315 c44.327-2.201,82.164,32.023,84.385,76.333c0.068,1.356,0.102,2.712,0.102,4.068c0,4.379-0.353,8.748-1.054,13.035 l-2.642-0.432c0.678-4.144,1.019-8.368,1.019-12.604c0-1.31-0.033-2.622-0.098-3.932l0,0 c-2.08-41.516-36.524-73.89-77.64-73.893c-1.308,0-2.617,0.032-3.938,0.098c-41.518,2.08-73.893,36.523-73.892,77.644 c0,1.305,0.033,2.617,0.099,3.934c2.146,42.835,38.736,75.954,81.577,73.794c14.085-0.706,27.688-5.205,39.338-13.009 l1.49,2.223c-12.053,8.074-26.125,12.728-40.694,13.458C2069.59,670.118,2068.231,670.152,2066.881,670.152z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1960.344,458.299l-8.429-12.788c2.955-6.514,4.893-13.546,5.633-20.869l13.705-6.815 c0.481-0.239,0.757-0.757,0.688-1.289l-2.371-18.218c-0.07-0.532-0.469-0.962-0.995-1.07l-14.993-3.081 c-2.59-6.89-6.262-13.192-10.786-18.732l4.875-14.52c0.171-0.509,0-1.07-0.425-1.398l-14.558-11.206 c-0.426-0.328-1.012-0.349-1.46-0.053l-12.788,8.429c-6.514-2.955-13.546-4.893-20.869-5.633l-6.815-13.706 c-0.239-0.481-0.757-0.757-1.289-0.688l-18.219,2.371c-0.532,0.069-0.962,0.469-1.07,0.995l-3.081,14.993 c-6.891,2.59-13.192,6.262-18.733,10.786l-14.52-4.876c-0.509-0.171-1.07,0-1.398,0.426l-11.206,14.559 c-0.328,0.426-0.349,1.012-0.054,1.46l8.429,12.788c-2.956,6.514-4.893,13.546-5.633,20.869l-13.706,6.815 c-0.481,0.239-0.757,0.757-0.688,1.289l2.371,18.219c0.069,0.532,0.469,0.962,0.995,1.07l14.993,3.081 c2.589,6.891,6.263,13.192,10.786,18.733l-4.875,14.52c-0.171,0.509,0,1.07,0.425,1.398l14.558,11.206 c0.426,0.328,1.012,0.349,1.46,0.054l12.788-8.429c6.514,2.955,13.546,4.893,20.869,5.633l6.815,13.706 c0.239,0.48,0.757,0.757,1.289,0.687l18.218-2.371c0.532-0.069,0.962-0.468,1.07-0.994l3.081-14.993 c6.89-2.59,13.192-6.263,18.733-10.786l14.52,4.875c0.509,0.171,1.07,0,1.398-0.425l11.206-14.559 C1960.617,459.334,1960.639,458.747,1960.344,458.299z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045577408034663200070000017003876424063214235_",
    gradientUnits: "userSpaceOnUse",
    x1: 1873.1038,
    y1: 417.8376,
    x2: 1908.425,
    y2: 417.8376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045577408034663200070000017003876424063214235_)"
    },
    d: "M1890.786,435.488 c-7.033,0.001-13.695-4.231-16.435-11.159c-1.734-4.385-1.657-9.181,0.216-13.508c1.874-4.326,5.321-7.664,9.705-9.398 c9.05-3.577,19.326,0.871,22.906,9.921c1.734,4.385,1.657,9.181-0.217,13.508c-1.874,4.326-5.32,7.665-9.704,9.398 C1895.134,435.09,1892.942,435.488,1890.786,435.488z M1890.746,402.862c-1.829,0-3.688,0.337-5.49,1.05 c-3.72,1.471-6.643,4.303-8.233,7.974c-1.59,3.67-1.655,7.74-0.183,11.46c3.037,7.678,11.756,11.452,19.433,8.417 c3.719-1.471,6.644-4.303,8.233-7.974c1.59-3.671,1.655-7.74,0.183-11.46l0,0 C1902.365,406.453,1896.713,402.862,1890.746,402.862z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1953.829,494.391c-0.256,0-0.509-0.109-0.686-0.321c-0.315-0.379-0.264-0.941,0.114-1.256 c0.91-0.759,1.809-1.537,2.673-2.312c0.366-0.331,0.931-0.298,1.26,0.068c0.329,0.367,0.299,0.93-0.068,1.26 c-0.88,0.79-1.796,1.582-2.722,2.354C1954.233,494.323,1954.031,494.391,1953.829,494.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1890.774,517.237c-2.076,0-4.181-0.067-6.259-0.199c-0.491-0.031-0.865-0.455-0.834-0.947 c0.031-0.491,0.46-0.864,0.947-0.834c2.04,0.13,4.108,0.195,6.146,0.195l0.896-0.004c0.489-0.005,0.896,0.392,0.9,0.884 c0.004,0.493-0.392,0.895-0.884,0.9L1890.774,517.237z M1903.192,516.445c-0.442,0-0.826-0.328-0.883-0.779 c-0.063-0.489,0.283-0.936,0.771-0.998c2.314-0.296,4.651-0.683,6.948-1.148c0.483-0.101,0.953,0.214,1.051,0.698 c0.098,0.483-0.214,0.953-0.697,1.052c-2.339,0.473-4.719,0.867-7.076,1.169C1903.268,516.443,1903.23,516.445,1903.192,516.445 z M1873.113,515.632c-0.053,0-0.107-0.004-0.161-0.015c-2.342-0.428-4.698-0.948-7.002-1.544 c-0.477-0.123-0.764-0.61-0.64-1.086c0.124-0.477,0.608-0.771,1.087-0.64c2.263,0.585,4.577,1.095,6.876,1.516 c0.485,0.088,0.806,0.553,0.717,1.038C1873.911,515.331,1873.536,515.632,1873.113,515.632z M1921.364,512.334 c-0.375,0-0.724-0.238-0.848-0.614c-0.154-0.468,0.102-0.972,0.569-1.126c1.857-0.609,3.727-1.286,5.559-2.01 c0.352-0.14,0.703-0.28,1.053-0.423c0.458-0.189,0.977,0.032,1.163,0.489c0.186,0.457-0.033,0.978-0.489,1.163 c-0.355,0.145-0.712,0.288-1.07,0.43c-1.866,0.738-3.769,1.426-5.659,2.046C1921.55,512.32,1921.456,512.334,1921.364,512.334z  M1855.185,510.567c-0.108,0-0.217-0.019-0.322-0.06c-2.223-0.861-4.439-1.814-6.589-2.829 c-0.446-0.211-0.636-0.742-0.426-1.187c0.211-0.446,0.743-0.637,1.188-0.426c2.111,0.997,4.288,1.932,6.471,2.778 c0.46,0.179,0.687,0.695,0.51,1.154C1855.88,510.351,1855.542,510.567,1855.185,510.567z M1938.449,504.899 c-0.315,0-0.62-0.166-0.782-0.461c-0.238-0.431-0.081-0.974,0.35-1.213c2.051-1.131,4.082-2.35,6.037-3.621 c0.413-0.271,0.965-0.152,1.234,0.261c0.269,0.413,0.151,0.965-0.261,1.233c-1.992,1.295-4.061,2.537-6.148,3.689 C1938.743,504.863,1938.595,504.899,1938.449,504.899z M1838.525,502.235c-0.161,0-0.324-0.044-0.471-0.135 c-2.022-1.262-4.021-2.613-5.942-4.013c-0.398-0.29-0.485-0.849-0.195-1.246c0.29-0.398,0.848-0.487,1.247-0.195 c1.886,1.375,3.849,2.701,5.835,3.94c0.418,0.261,0.545,0.811,0.284,1.229C1839.114,502.086,1838.823,502.235,1838.525,502.235z  M1823.73,490.925c-0.217,0-0.434-0.078-0.606-0.238c-1.745-1.617-3.453-3.32-5.078-5.061c-0.336-0.361-0.317-0.925,0.043-1.261 c0.36-0.335,0.925-0.316,1.261,0.044c1.595,1.71,3.273,3.382,4.986,4.97c0.362,0.335,0.383,0.899,0.048,1.261 C1824.209,490.83,1823.97,490.925,1823.73,490.925z M1811.343,477.029c-0.275,0-0.545-0.126-0.721-0.364 c-1.406-1.918-2.761-3.914-4.026-5.932c-0.262-0.417-0.135-0.968,0.282-1.229c0.417-0.265,0.968-0.137,1.23,0.281 c1.243,1.981,2.573,3.941,3.954,5.824c0.291,0.398,0.205,0.956-0.192,1.247C1811.71,476.973,1811.525,477.029,1811.343,477.029z  M1801.804,461.03c-0.334,0-0.654-0.188-0.806-0.51c-0.949-1.999-1.845-4.063-2.664-6.134l-0.177-0.45 c-0.178-0.46,0.049-0.977,0.509-1.155c0.456-0.177,0.976,0.05,1.154,0.509l0.172,0.441c0.805,2.033,1.685,4.061,2.617,6.024 c0.211,0.445,0.022,0.977-0.423,1.188C1802.063,461.002,1801.933,461.03,1801.804,461.03z M1795.422,443.527 c-0.396,0-0.758-0.266-0.862-0.667c-0.603-2.304-1.129-4.659-1.563-6.997c-0.09-0.484,0.23-0.95,0.714-1.04 c0.481-0.094,0.95,0.23,1.04,0.714c0.426,2.296,0.943,4.608,1.535,6.872c0.125,0.477-0.16,0.964-0.637,1.089 C1795.572,443.517,1795.496,443.527,1795.422,443.527z M1792.439,425.137c-0.466,0-0.859-0.362-0.89-0.834 c-0.14-2.138-0.211-4.306-0.21-6.444l0.003-0.724c0.003-0.491,0.402-0.886,0.892-0.886c0.002,0,0.004,0,0.007,0 c0.493,0.004,0.889,0.406,0.885,0.898l-0.003,0.712c0,2.1,0.069,4.229,0.207,6.327c0.032,0.491-0.34,0.916-0.832,0.949 C1792.478,425.136,1792.459,425.137,1792.439,425.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1793.007,406.46c-0.037,0-0.075-0.003-0.113-0.007c-0.489-0.062-0.835-0.509-0.773-0.997 c0.151-1.192,0.324-2.39,0.516-3.56c0.079-0.486,0.535-0.818,1.025-0.737c0.486,0.08,0.816,0.538,0.736,1.025 c-0.188,1.15-0.359,2.327-0.507,3.498C1793.834,406.13,1793.45,406.46,1793.007,406.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1831.398,340.095c-0.271,0-0.537-0.122-0.713-0.355c-0.297-0.394-0.218-0.953,0.175-1.249 c0.951-0.718,1.931-1.43,2.913-2.115c0.404-0.28,0.96-0.183,1.242,0.221c0.282,0.404,0.183,0.96-0.221,1.242 c-0.964,0.673-1.926,1.371-2.86,2.075C1831.774,340.036,1831.585,340.095,1831.398,340.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1989.108,424.163c-0.017,0-0.034-0.001-0.051-0.002c-0.492-0.027-0.869-0.448-0.841-0.94 c0.101-1.8,0.152-3.623,0.152-5.419c0-0.503-0.004-1.006-0.012-1.51c-0.007-0.493,0.385-0.898,0.878-0.906 c0.487,0.029,0.898,0.385,0.906,0.878c0.008,0.512,0.012,1.025,0.012,1.538c0,1.829-0.052,3.685-0.154,5.518 C1989.971,423.795,1989.578,424.163,1989.108,424.163z M1988.41,405.844c-0.44,0-0.823-0.326-0.883-0.774 c-0.303-2.281-0.692-4.579-1.156-6.832c-0.099-0.483,0.211-0.955,0.694-1.054c0.48-0.1,0.953,0.211,1.054,0.693 c0.473,2.295,0.869,4.635,1.177,6.957c0.065,0.489-0.278,0.937-0.767,1.002C1988.489,405.841,1988.449,405.844,1988.41,405.844z  M1984.313,387.975c-0.375,0-0.724-0.238-0.847-0.613c-0.599-1.817-1.261-3.645-1.967-5.43 c-0.142-0.358-0.286-0.716-0.432-1.072c-0.187-0.457,0.032-0.977,0.487-1.164c0.457-0.185,0.978,0.033,1.163,0.488 c0.149,0.363,0.295,0.727,0.439,1.091c0.719,1.818,1.393,3.678,2.003,5.529c0.154,0.468-0.1,0.972-0.568,1.126 C1984.5,387.961,1984.406,387.975,1984.313,387.975z M1977.002,371.164c-0.315,0-0.62-0.167-0.783-0.463 c-1.109-2.017-2.303-4.018-3.551-5.947c-0.267-0.414-0.149-0.966,0.265-1.234c0.414-0.267,0.966-0.149,1.234,0.265 c1.27,1.965,2.487,4.003,3.616,6.057c0.237,0.431,0.08,0.974-0.352,1.211C1977.295,371.128,1977.147,371.164,1977.002,371.164z  M1966.71,355.999c-0.257,0-0.512-0.111-0.688-0.324c-1.465-1.774-3.012-3.517-4.598-5.181c-0.34-0.357-0.326-0.922,0.03-1.261 c0.357-0.34,0.921-0.328,1.261,0.031c1.615,1.694,3.191,3.47,4.682,5.276c0.314,0.38,0.26,0.943-0.12,1.256 C1967.111,355.932,1966.91,355.999,1966.71,355.999z M1953.775,343.021c-0.201,0-0.403-0.067-0.57-0.206 c-1.767-1.469-3.612-2.894-5.482-4.236c-0.4-0.288-0.492-0.844-0.205-1.245c0.287-0.401,0.843-0.494,1.245-0.205 c1.904,1.366,3.783,2.817,5.582,4.312c0.379,0.315,0.431,0.877,0.116,1.256C1954.285,342.911,1954.031,343.021,1953.775,343.021 z M1938.651,332.669c-0.147,0-0.295-0.036-0.432-0.112c-2.005-1.115-4.081-2.175-6.171-3.151 c-0.446-0.208-0.639-0.74-0.431-1.186c0.209-0.447,0.74-0.637,1.186-0.431c2.127,0.994,4.241,2.073,6.283,3.209 c0.431,0.24,0.586,0.782,0.346,1.213C1939.268,332.504,1938.964,332.669,1938.651,332.669z M1843.959,332.047 c-0.318,0-0.625-0.17-0.786-0.469c-0.234-0.434-0.072-0.975,0.362-1.208c2.055-1.105,4.184-2.156,6.327-3.122 c0.45-0.2,0.977-0.003,1.18,0.447c0.203,0.449,0.002,0.977-0.447,1.18c-2.105,0.948-4.196,1.98-6.214,3.066 C1844.247,332.013,1844.102,332.047,1843.959,332.047z M1921.875,325.283c-0.094,0-0.189-0.015-0.283-0.046 c-2.176-0.727-4.412-1.387-6.646-1.96c-0.477-0.123-0.765-0.609-0.642-1.086c0.123-0.477,0.608-0.762,1.086-0.642 c2.275,0.585,4.552,1.256,6.768,1.997c0.467,0.156,0.719,0.661,0.563,1.129C1922.597,325.047,1922.249,325.283,1921.875,325.283 z M1860.835,324.884c-0.378,0-0.728-0.241-0.85-0.62c-0.15-0.47,0.109-0.971,0.578-1.121c2.238-0.716,4.524-1.359,6.792-1.91 c0.478-0.122,0.961,0.177,1.078,0.656c0.116,0.479-0.177,0.961-0.656,1.078c-2.229,0.542-4.473,1.173-6.671,1.876 C1861.016,324.87,1860.924,324.884,1860.835,324.884z M1904.023,321.117c-0.041,0-0.082-0.003-0.122-0.009 c-2.276-0.312-4.595-0.546-6.894-0.695c-0.492-0.032-0.864-0.457-0.832-0.948c0.032-0.492,0.469-0.839,0.948-0.833 c2.341,0.152,4.703,0.39,7.02,0.709c0.488,0.066,0.83,0.517,0.763,1.004C1904.844,320.793,1904.462,321.117,1904.023,321.117z  M1878.738,320.946c-0.444,0-0.828-0.331-0.884-0.783c-0.06-0.489,0.287-0.934,0.776-0.994c2.325-0.287,4.69-0.493,7.029-0.614 c0.484-0.025,0.912,0.353,0.937,0.845c0.025,0.492-0.353,0.912-0.845,0.937c-2.297,0.118-4.619,0.321-6.902,0.602 C1878.812,320.944,1878.775,320.946,1878.738,320.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1987.134,439.003c-0.061,0-0.123-0.006-0.186-0.019c-0.482-0.102-0.79-0.575-0.688-1.058 c0.242-1.145,0.467-2.312,0.668-3.47c0.085-0.483,0.544-0.808,1.032-0.726c0.485,0.085,0.811,0.546,0.726,1.032 c-0.205,1.178-0.434,2.367-0.68,3.533C1987.918,438.715,1987.547,439.003,1987.134,439.003z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078764651119477674360000006215599502478263467_",
    gradientUnits: "userSpaceOnUse",
    x1: 1844.764,
    y1: 417.6228,
    x2: 1936.1094,
    y2: 417.6228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078764651119477674360000006215599502478263467_)"
    },
    d: "M1890.405,463.297 c-22.582,0-42.265-16.798-45.255-39.779c-0.26-1.993-0.385-3.974-0.385-5.933c0.004-22.579,16.802-42.256,39.779-45.247 c12.095-1.573,24.082,1.657,33.749,9.097c9.666,7.44,15.857,18.2,17.431,30.297l0,0c0.42,3.233,0.498,6.503,0.23,9.719 l-2.667-0.221c0.098-1.177,0.146-2.362,0.146-3.55c0-1.868-0.121-3.742-0.363-5.603c-0.024-0.184-0.049-0.367-0.075-0.55 c-1.551-10.853-7.063-20.528-15.596-27.39c-0.244-0.196-0.49-0.389-0.739-0.581c-9.1-7.004-20.378-10.039-31.771-8.564 c-21.631,2.816-37.444,21.341-37.448,42.595c0,1.844,0.119,3.709,0.363,5.586c3.059,23.507,24.666,40.141,48.181,37.085 c7.729-1.006,15.027-4.081,21.104-8.89l1.661,2.098c-6.458,5.111-14.21,8.378-22.421,9.446 C1894.339,463.17,1892.361,463.297,1890.405,463.297z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128466987178060373370000000622898890796443045_",
    gradientUnits: "userSpaceOnUse",
    x1: 1242.3311,
    y1: 627.5416,
    x2: 1014.3087,
    y2: 1071.5856
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128466987178060373370000000622898890796443045_)"
    },
    d: "M1100.149,1079.044l-119.757-87.762 l120.073-97.459c3.473-2.818,4.003-7.918,1.184-11.391c-2.818-3.473-7.917-4.005-11.391-1.184L962.035,985.321 c-1.949,1.581-3.054,3.978-2.992,6.488c0.062,2.51,1.284,4.848,3.308,6.332l128.223,93.967c1.443,1.057,3.119,1.566,4.781,1.566 c2.492,0,4.952-1.147,6.539-3.311C1104.537,1086.756,1103.756,1081.688,1100.149,1079.044z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070799400814914944500000000189847369971434675_",
    gradientUnits: "userSpaceOnUse",
    x1: 1402.8889,
    y1: 709.9908,
    x2: 1174.8657,
    y2: 1154.0361
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070799400814914944500000000189847369971434675_)"
    },
    d: "M1354.212,985.321l-128.223-104.073 c-3.476-2.823-8.574-2.289-11.391,1.184c-2.82,3.473-2.29,8.573,1.183,11.391l120.073,97.459l-119.757,87.762 c-3.607,2.644-4.388,7.712-1.745,11.319c1.587,2.164,4.046,3.311,6.539,3.311c1.66,0,3.337-0.509,4.781-1.566l128.223-93.967 c2.025-1.484,3.246-3.822,3.308-6.332S1356.161,986.903,1354.212,985.321z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061449124491911446260000008849195916090062507_",
    gradientUnits: "userSpaceOnUse",
    x1: 1321.8569,
    y1: 668.3787,
    x2: 1093.8346,
    y2: 1112.4222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061449124491911446260000008849195916090062507_)"
    },
    d: "M1180.825,858.241 c-4.401-0.825-8.63,2.068-9.457,6.461l-47.357,251.694c-0.827,4.396,2.066,8.629,6.461,9.456 c1.006,0.189,2.002,0.184,2.951,0.011c3.203-0.585,5.868-3.082,6.505-6.472l47.356-251.693 C1188.113,863.301,1185.22,859.067,1180.825,858.241z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098198206246837785540000007879517427545895594_",
    gradientUnits: "userSpaceOnUse",
    x1: 2233.6538,
    y1: 460.7386,
    x2: 2089.6394,
    y2: 709.7634
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098198206246837785540000007879517427545895594_)"
    },
    d: "M1616.127,935.353 c-2.033,95.928-8.625,426.818-5.478,544.075c0.333,12.422,8.846,22.393,19.464,22.799c52.518,2.011,245.046,7.107,330.948,2.89 c17.892-0.878,32.12-17.832,32.492-38.777c1.785-100.688,5.723-383.886-3.637-513.619 c-1.122-15.544-11.551-27.922-24.819-29.475c-57.195-6.694-250.551-23.055-324.765-17.421 C1626.948,906.841,1616.46,919.667,1616.127,935.353z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060733480885271008370000013303408558820621503_",
    gradientUnits: "userSpaceOnUse",
    x1: 1911.5446,
    y1: 1078.969,
    x2: 2971.0808,
    y2: 90.9077
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060733480885271008370000013303408558820621503_)"
    },
    d: "M1639.561,964.784 c-2.827,77.428-11.743,335.012-8.913,430.261c0.414,13.922,9.793,25.179,21.68,25.993c48.944,3.351,215.93,10.739,287.719,4.014 c12.927-1.211,23.071-13.441,23.769-28.59c3.638-78.992,14.083-318.839,11.371-413.021 c-0.433-15.024-10.381-27.295-23.181-28.639c-52.95-5.562-230.391-18.795-291.395-14.901 C1649.159,940.631,1640.05,951.379,1639.561,964.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M1745.921,922.587L1745.921,922.587c0,2.943,1.961,5.371,4.473,5.525 c12.404,0.76,47.348,2.91,62.965,3.97c3.079,0.209,5.496-3.029,4.912-6.572l-0.1-0.604c-0.398-2.417-2.112-4.237-4.208-4.462 c-10.556-1.132-42.409-4.269-63.513-3.388C1747.915,917.162,1745.921,919.619,1745.921,922.587z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165226711152492728860000004259137612398116015_",
    gradientUnits: "userSpaceOnUse",
    x1: 2050.7971,
    y1: 927.2482,
    x2: 1816.7738,
    y2: 1176.2732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165226711152492728860000004259137612398116015_)"
    },
    d: "M1943.783,1098.652l0.622-90.856 c0.075-10.952-6.971-20.197-16.044-20.88l-235.444-17.797c-9.551-0.72-17.463,8.104-17.89,19.622 c0,0-10.776,273.164-10.776,276.491v-0.004l-3.854,107.244c-0.428,11.53,7.146,21.236,16.722,21.529l247.144,7.561 c9.562,0.292,17.482-9.234,17.561-20.758l1.17-168.629h-0.009l0.764-113.522H1943.783z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1766.329,1237.229l-76.736-56.235l76.939-62.448c2.225-1.806,2.565-5.074,0.758-7.299 c-1.806-2.225-5.073-2.566-7.299-0.758l-82.161,66.686c-1.249,1.013-1.957,2.549-1.917,4.157c0.039,1.608,0.822,3.106,2.12,4.057 l82.161,60.211c0.925,0.677,1.998,1.003,3.063,1.003c1.597,0,3.173-0.735,4.19-2.122 C1769.14,1242.17,1768.64,1238.923,1766.329,1237.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1929.123,1177.174l-82.161-66.686c-2.227-1.809-5.494-1.467-7.299,0.758 c-1.807,2.225-1.467,5.493,0.758,7.299l76.939,62.448l-76.736,56.235c-2.312,1.694-2.812,4.941-1.118,7.253 c1.017,1.387,2.593,2.122,4.19,2.122c1.064,0,2.138-0.326,3.063-1.003l82.161-60.211c1.297-0.951,2.08-2.449,2.12-4.057 C1931.08,1179.723,1930.372,1178.188,1929.123,1177.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1818.023,1095.745c-2.82-0.529-5.53,1.325-6.06,4.14l-30.344,161.277 c-0.53,2.817,1.324,5.529,4.14,6.059c0.645,0.121,1.283,0.118,1.891,0.007c2.052-0.375,3.76-1.975,4.168-4.147l30.344-161.276 C1822.693,1098.988,1820.839,1096.275,1818.023,1095.745z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M792.105,1242.193l718.277-3.141c6.869-0.062,12.46,5.511,12.421,12.38l-1.533,251.418 c-0.04,6.915-5.753,12.441-12.665,12.235c-63.336-1.888-712.508-10.22-724.921-9.701c-12.267,0.513-5.602-198.034-3.771-251.313 C780.139,1247.485,785.514,1242.252,792.105,1242.193z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089576490669844743540000010594841425177708456_",
    gradientUnits: "userSpaceOnUse",
    x1: 786.8316,
    y1: 1377.0723,
    x2: 1512.4072,
    y2: 1377.0723
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089576490669844743540000010594841425177708456_)"
    },
    d: "M1508.979,1504.697l-0.064-0.002 c-40.505-1.209-428.62-6.052-615.139-8.379c-53.944-0.674-92.92-1.16-103.218-1.305l-0.414-0.006l-0.072-0.407 c-4.398-24.809-4.319-107.857,0.228-240.169c0.036-1.024,0.87-1.834,1.898-1.842l718.277-3.141c0.673,0,1.119,0.308,1.375,0.564 c0.368,0.369,0.56,0.841,0.556,1.362l-1.533,251.418C1510.869,1503.843,1510.019,1504.697,1508.979,1504.697z M790.987,1494.018 c10.894,0.151,49.556,0.634,102.802,1.299c186.521,2.327,574.642,7.17,615.156,8.379l0.054,0.002 c0.471,0,0.873-0.408,0.875-0.911l1.533-251.419c0.002-0.257-0.085-0.469-0.265-0.65c-0.178-0.179-0.401-0.27-0.663-0.27 l-718.273,3.141c-0.49,0.004-0.888,0.389-0.905,0.877C786.78,1385.988,786.673,1468.782,790.987,1494.018z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057124457811716688450000010227093858518929545_",
    gradientUnits: "userSpaceOnUse",
    x1: 822.8372,
    y1: 1307.1223,
    x2: 1108.1067,
    y2: 1307.1223
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057124457811716688450000010227093858518929545_)"
    },
    d: "M822.837,1307.122L822.837,1307.122 c0,6.799,2.269,12.31,5.067,12.31h275.137c2.798,0,5.066-5.511,5.066-12.31l0,0c0-6.799-2.268-12.311-5.066-12.311H827.904 C825.106,1294.812,822.837,1300.323,822.837,1307.122z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096028492927309228610000004043843833356404877_",
    gradientUnits: "userSpaceOnUse",
    x1: 822.8372,
    y1: 1349.0892,
    x2: 1108.1067,
    y2: 1349.0892
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096028492927309228610000004043843833356404877_)"
    },
    d: "M822.837,1349.089L822.837,1349.089 c0,6.799,2.269,12.31,5.067,12.31h275.137c2.798,0,5.066-5.512,5.066-12.31l0,0c0-6.799-2.268-12.311-5.066-12.311H827.904 C825.106,1336.779,822.837,1342.29,822.837,1349.089z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083051640213894793590000017277625239686277533_",
    gradientUnits: "userSpaceOnUse",
    x1: 822.8372,
    y1: 1391.0559,
    x2: 1108.1067,
    y2: 1391.0559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083051640213894793590000017277625239686277533_)"
    },
    d: "M822.837,1391.056L822.837,1391.056 c0,6.799,2.269,12.311,5.067,12.311h275.137c2.798,0,5.066-5.512,5.066-12.311l0,0c0-6.799-2.268-12.311-5.066-12.311H827.904 C825.106,1378.745,822.837,1384.257,822.837,1391.056z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111907924223111553120000006980971993552563102_",
    gradientUnits: "userSpaceOnUse",
    x1: 822.8372,
    y1: 1433.0227,
    x2: 1108.1067,
    y2: 1433.0227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111907924223111553120000006980971993552563102_)"
    },
    d: "M822.837,1433.023L822.837,1433.023 c0,6.799,2.269,12.31,5.067,12.31h275.137c2.798,0,5.066-5.511,5.066-12.31l0,0c0-6.799-2.268-12.31-5.066-12.31H827.904 C825.106,1420.712,822.837,1426.224,822.837,1433.023z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2898 -0.9571 0.9571 0.2898 -422.8338 2061.7769)",
    style: {
      fill: "#BDD0FB"
    },
    cx: 1177.815,
    cy: 1315.795,
    rx: 47.86,
    ry: 47.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -550.5949 1302.3365)",
    style: {
      fill: "#BDD0FB"
    },
    cx: 1296.762,
    cy: 1315.795,
    rx: 47.86,
    ry: 47.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -516.864 1386.9034)",
    style: {
      fill: "#BDD0FB"
    },
    cx: 1415.708,
    cy: 1317.362,
    rx: 47.86,
    ry: 47.86
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008114902653683874400000015070219901765539984_",
    gradientUnits: "userSpaceOnUse",
    x1: 1285.3539,
    y1: 906.1852,
    x2: 1217.3536,
    y2: 1166.1853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008114902653683874400000015070219901765539984_)"
    },
    d: "M1206.253,1305.68 c1.481,3.603,2.304,7.545,2.304,11.682c0,16.979-13.764,30.742-30.742,30.742c-16.979,0-30.742-13.764-30.742-30.742 c0-16.978,13.764-30.742,30.742-30.742c0.52,0,1.037,0.014,1.551,0.039v-7.793c-0.514-0.021-1.031-0.034-1.551-0.034 c-21.279,0-38.529,17.25-38.529,38.529c0,21.279,17.25,38.53,38.529,38.53c21.279,0,38.53-17.25,38.53-38.53 c0-5.24-1.048-10.234-2.943-14.787L1206.253,1305.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020356994806741996790000013055889705695903382_",
    gradientUnits: "userSpaceOnUse",
    x1: 1391.0413,
    y1: 933.826,
    x2: 1323.0409,
    y2: 1193.8263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020356994806741996790000013055889705695903382_)"
    },
    d: "M1312.62,1343.371 c-4.743,2.994-10.357,4.732-16.38,4.732c-16.979,0-30.742-13.764-30.742-30.742c0-16.978,13.764-30.742,30.742-30.742 c0.52,0,1.037,0.014,1.551,0.039v-7.793c-0.514-0.021-1.031-0.034-1.551-0.034c-21.279,0-38.529,17.25-38.529,38.529 c0,21.279,17.25,38.53,38.529,38.53c7.426,0,14.361-2.103,20.244-5.744L1312.62,1343.371z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048469542064487512420000009480118580717798041_",
    gradientUnits: "userSpaceOnUse",
    x1: 1507.116,
    y1: 964.1843,
    x2: 1439.1157,
    y2: 1224.1846
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048469542064487512420000009480118580717798041_)"
    },
    d: "M1441.362,1334.646 c-5.533,8.123-14.854,13.458-25.423,13.458c-16.979,0-30.742-13.764-30.742-30.742c0-16.978,13.764-30.742,30.742-30.742 c0.52,0,1.037,0.014,1.551,0.039v-7.793c-0.515-0.021-1.031-0.034-1.551-0.034c-21.279,0-38.529,17.25-38.529,38.529 c0,21.279,17.25,38.53,38.529,38.53c13.164,0,24.783-6.603,31.734-16.677L1441.362,1334.646z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113341369183544602290000015415096788816961191_",
    gradientUnits: "userSpaceOnUse",
    x1: 1129.9546,
    y1: 1392.7927,
    x2: 1225.6755,
    y2: 1392.7927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113341369183544602290000015415096788816961191_)"
    },
    d: "M1216.811,1383.929h-77.993 c-4.896,0-8.864,3.968-8.864,8.864s3.968,8.864,8.864,8.864h77.993c4.895,0,8.864-3.968,8.864-8.864 S1221.707,1383.929,1216.811,1383.929z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058586678168279976730000001276452032386969758_",
    gradientUnits: "userSpaceOnUse",
    x1: 1248.9017,
    y1: 1392.7927,
    x2: 1344.6219,
    y2: 1392.7927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058586678168279976730000001276452032386969758_)"
    },
    d: "M1335.758,1383.929h-77.993 c-4.895,0-8.864,3.968-8.864,8.864s3.968,8.864,8.864,8.864h77.993c4.896,0,8.864-3.968,8.864-8.864 S1340.654,1383.929,1335.758,1383.929z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085964351655583193510000013301815649001687686_",
    gradientUnits: "userSpaceOnUse",
    x1: 1367.8483,
    y1: 1392.7927,
    x2: 1463.5686,
    y2: 1392.7927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085964351655583193510000013301815649001687686_)"
    },
    d: "M1376.713,1401.657h77.992 c4.895,0,8.864-3.968,8.864-8.864s-3.969-8.864-8.864-8.864h-77.992c-4.896,0-8.864,3.968-8.864,8.864 S1371.817,1401.657,1376.713,1401.657z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083046830612332552380000009119704369993279622_",
    gradientUnits: "userSpaceOnUse",
    x1: 1129.9546,
    y1: 1446.4688,
    x2: 1225.6755,
    y2: 1446.4688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083046830612332552380000009119704369993279622_)"
    },
    d: "M1216.811,1411.506h-77.993 c-4.896,0-8.864,3.969-8.864,8.864v52.199c0,4.896,3.968,8.864,8.864,8.864h77.993c4.895,0,8.864-3.968,8.864-8.864v-52.199 C1225.676,1415.474,1221.707,1411.506,1216.811,1411.506z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148621854986600270440000009121257612914237864_",
    gradientUnits: "userSpaceOnUse",
    x1: 1248.9017,
    y1: 1446.4688,
    x2: 1344.6219,
    y2: 1446.4688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148621854986600270440000009121257612914237864_)"
    },
    d: "M1335.758,1411.506h-77.993 c-4.895,0-8.864,3.969-8.864,8.864v52.199c0,4.896,3.968,8.864,8.864,8.864h77.993c4.896,0,8.864-3.968,8.864-8.864v-52.199 C1344.622,1415.474,1340.654,1411.506,1335.758,1411.506z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009586356088990803240000012032833778888236975_",
    gradientUnits: "userSpaceOnUse",
    x1: 1367.8483,
    y1: 1446.4688,
    x2: 1463.5686,
    y2: 1446.4688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009586356088990803240000012032833778888236975_)"
    },
    d: "M1454.705,1411.506h-77.992 c-4.896,0-8.864,3.969-8.864,8.864v52.199c0,4.896,3.969,8.864,8.864,8.864h77.992c4.895,0,8.864-3.968,8.864-8.864v-52.199 C1463.569,1415.474,1459.6,1411.506,1454.705,1411.506z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M643.184,1379.049c0,0-1.744,9.869-2.598,19.639c-0.334,3.818,2.609,7.133,6.439,7.293 c13.01,0.542,40.839,1.595,50.826,1.15c1.501-0.067,2.483-1.604,1.927-3l0,0c-0.466-1.17-1.364-2.116-2.508-2.641l-45.969-21.127 L643.184,1379.049z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088849912367013186360000005883267635288674953_",
    gradientUnits: "userSpaceOnUse",
    x1: 4270.1362,
    y1: 1379.0082,
    x2: 4285.0889,
    y2: 1379.0082,
    gradientTransform: "matrix(1 0 0 1 -3628.3811 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088849912367013186360000005883267635288674953_)"
    },
    d: "M641.755,1373.25l1.401,11.805 c0,0,8.052,3.749,13.552-0.472l-3.335-13.156L641.755,1373.25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029027876969371967230000000004926817577247406_",
    gradientUnits: "userSpaceOnUse",
    x1: 3367.3562,
    y1: 2804.4805,
    x2: 3458.3562,
    y2: 2647.4802,
    gradientTransform: "matrix(1 0 0 1 -3628.3811 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029027876969371967230000000004926817577247406_)"
    },
    d: "M642.808,1151.312 c-0.605,3.083-3.247,153.84,12.867,221.399c0.263,1.102-0.296,2.239-1.345,2.668c-2.472,1.01-7.317,2.472-13.124,2.667 c-1.798,0.06-3.411-1.108-3.918-2.834c-4.606-15.675-26.679-94.21-29.559-169.232c-3.217-83.83,0-2.854,0-2.854l1.887-51.819 L642.808,1151.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M590.304,1384.198c0,0-2.775,4.982-5.462,18.222c-0.485,2.391,1.185,4.68,3.614,4.918 c4.296,0.423,10.91,0.966,16.207,0.929c2.442-0.017,4.348-2.143,4.054-4.567c-0.587-4.833-2.415-12.761-8.062-18.941 L590.304,1384.198z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070839948703848456910000004336488463040956086_",
    gradientUnits: "userSpaceOnUse",
    x1: 4216.2476,
    y1: 1378.2415,
    x2: 4229.1577,
    y2: 1378.2415,
    gradientTransform: "matrix(1 0 0 1 -3628.3811 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070839948703848456910000004336488463040956086_)"
    },
    d: "M587.867,1369.014l3.273,17.852 c0,0,3.236,2.407,9.637,0.662l-1.562-19.208L587.867,1369.014z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003823661374781388200000013154413928593397890_",
    gradientUnits: "userSpaceOnUse",
    x1: 3337.4604,
    y1: 2787.1526,
    x2: 3428.4604,
    y2: 2630.1526,
    gradientTransform: "matrix(1 0 0 1 -3628.3811 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003823661374781388200000013154413928593397890_)"
    },
    d: "M579.025,1155.938 c-13.18,79.54,2.859,196.591,8.268,219.5c0.331,1.403,1.463,2.477,2.885,2.713c2.414,0.4,6.39,0.727,10.309-0.411 c1.35-0.392,2.299-1.61,2.354-3.015c0.726-18.521-0.58-132.227,11.7-177.164c0.622-2.277,2.013-4.263,3.937-5.631l23.835-16.945 l1.827-27.39L579.025,1155.938z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039096336644044334090000005181718959548162995_",
    gradientUnits: "userSpaceOnUse",
    x1: -1703.5441,
    y1: 2376.4524,
    x2: -1935.5435,
    y2: 2632.4521,
    gradientTransform: "matrix(-1 0 0 1 110.9012 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039096336644044334090000005181718959548162995_)"
    },
    d: "M663.007,1005.224 c-39.497-0.653-83.077,10.371-83.077,10.371c-11.773,68.697-2.059,147.933-2.059,147.933 c30.577,8.018,65.071-4.903,65.071-4.903c5.082-28.714,28.794-109.523,28.794-109.523c19.298-2.395,35.196-7.963,48.288-15.324 c-9.986-11.576-14.694-26.304-16.738-35.011C689.32,1003.108,675.189,1005.426,663.007,1005.224z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115497532362451251680000008620579579822187692_",
    gradientUnits: "userSpaceOnUse",
    x1: -677.587,
    y1: 962.9117,
    x2: -449.4256,
    y2: 1102.4095,
    gradientTransform: "matrix(-1 0 0 1 110.9012 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115497532362451251680000008620579579822187692_)"
    },
    d: "M779.674,947.047 c-3.88-4.686-8.791-2.469-8.791-2.469c-5.812,24.552-36.288,44.459-67.599,54.19c2.045,8.707,6.752,23.436,16.738,35.011 C771.985,1004.563,779.674,947.047,779.674,947.047z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135664182277383631690000018050818265252481447_",
    gradientUnits: "userSpaceOnUse",
    x1: -679.5424,
    y1: 907.8064,
    x2: -653.1608,
    y2: 983.1827,
    gradientTransform: "matrix(-1 0 0 1 110.9012 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135664182277383631690000018050818265252481447_)"
    },
    d: "M778.733,948.239 c0.406,1.291-4.296,3.256-7.063-2.023c-0.097-2.53-1.635-13.368-0.124-15.429c8.051-10.977,23.661-24.736,23.661-24.736 c2.638,2.603,0.465,5.16,0.465,5.16l-7.573,7.888c1.584,2.862,3.516,5.278,4.421,8.74c0.686,2.622,0.266,5.424-1.058,7.81 c-1.329,2.394-3.143,5.507-4.857,7.943C783.36,948.204,778.733,948.239,778.733,948.239z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076597728720391648630000014313972365001335985_",
    gradientUnits: "userSpaceOnUse",
    x1: 774.9302,
    y1: 874.2399,
    x2: 779.4302,
    y2: 916.2397
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076597728720391648630000014313972365001335985_)"
    },
    d: "M784.786,924.218l-6.901,5.85 l-2.167,5.824l6.153,6.825c0,0,2.069-11.556,3.606-14.057C787.016,926.159,786.218,924.95,784.786,924.218z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144296978294311927360000004828555183230252957_",
    gradientUnits: "userSpaceOnUse",
    x1: -1676.9237,
    y1: 2400.574,
    x2: -1908.9237,
    y2: 2656.5745,
    gradientTransform: "matrix(-1 0 0 1 110.9012 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144296978294311927360000004828555183230252957_)"
    },
    d: "M595.079,1053.84l-15.15-38.245 c0,0-36.893,25.067-42.96,56.849c6.971,0.513,19.656,2.327,32.071,8.596C571.769,1066.033,595.079,1053.84,595.079,1053.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085930273727363174300000013905128950408208521_",
    gradientUnits: "userSpaceOnUse",
    x1: 4164.5098,
    y1: 1097.1202,
    x2: 4261.1812,
    y2: 1097.1202,
    gradientTransform: "matrix(1 0 0 1 -3628.3811 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085930273727363174300000013905128950408208521_)"
    },
    d: "M627.318,1089.827 c0,0-41.421,23.409-55.397,3.421c-2.902-4.151-3.595-8.276-2.881-12.208c-12.416-6.269-25.1-8.083-32.071-8.596 c-1.829,9.581-0.862,19.771,4.768,30.071c24.481,44.783,91.063-2.475,91.063-2.475L627.318,1089.827z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160890534170099952190000007168405957614914218_",
    gradientUnits: "userSpaceOnUse",
    x1: 769.6287,
    y1: 903.0332,
    x2: 722.6286,
    y2: 981.0331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160890534170099952190000007168405957614914218_)"
    },
    d: "M622.342,1119.442l22.606-78.945 c0.256-0.896,1.021-1.55,1.947-1.658c4.096-0.478,15.964-1.819,29.667-2.978c16.506-1.396,35.674-2.527,47.128-1.565 c1.628,0.137,2.612,1.859,1.888,3.324c-6.513,13.177-33.306,66.781-46.723,84.341c-0.445,0.582-1.132,0.922-1.864,0.915 l-52.45-0.488C623.015,1122.374,621.922,1120.909,622.342,1119.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M678.906,1029.016l16.39-2.731c0.873-0.145,1.588,0.689,1.31,1.529l-1.622,4.916 c-0.141,0.428-0.514,0.738-0.961,0.797l-15.772,2.107c-0.816,0.109-1.489-0.633-1.301-1.434l1.004-4.292 C678.063,1029.446,678.438,1029.094,678.906,1029.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M666.634,1042.892l1.35-7.033c0.135-0.705,0.718-1.238,1.432-1.311l33.104-3.359 c1.114-0.113,2.007,0.908,1.745,1.997l-2.105,8.764c-0.168,0.701-0.779,1.208-1.499,1.244l-32.349,1.628 C667.26,1044.875,666.436,1043.927,666.634,1042.892z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088093774396799502000000014571341550268214710_",
    gradientUnits: "userSpaceOnUse",
    x1: 670.0805,
    y1: 1013.3862,
    x2: 654.0806,
    y2: 1050.3861
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088093774396799502000000014571341550268214710_)"
    },
    d: "M627.804,1100.369 c0,0-3.149-12.949-1.879-17.542c1.27-4.594,3.732-10.501,11.935-9.188c8.203,1.313,17.881,4.768,17.881,4.768 s-0.489,5.984-6.724,4.053l3.867,2.991c0,0-0.553,4.791-5.819,2.231l3.596,3.967c0,0-2.262,3.935-6.136,1.411 C640.649,1090.538,638.791,1101.928,627.804,1100.369z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178886989014864563020000009611507867335327410_",
    gradientUnits: "userSpaceOnUse",
    x1: 634.7112,
    y1: 972.2322,
    x2: 618.7112,
    y2: 1049.2321
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178886989014864563020000009611507867335327410_)"
    },
    d: "M623,973.159l-12.567,36.344 c-0.208,0.602,0.039,1.268,0.597,1.577c3.426,1.894,15.768,7.369,30.641-2.061c1.549-0.982,2.604-2.584,2.839-4.404l4.07-31.456 H623z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078746025521398327160000008430606000701200040_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.9323,
    y1: 4555.7617,
    x2: 195.4325,
    y2: 4500.7622,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 2026.8594 -1476.3188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078746025521398327160000008430606000701200040_)"
    },
    d: "M650.344,939.503 c0,0,13.8,25.978,12.031,36.471c-1.769,10.494-18.872,9.74-33.807,1.218l-10.437-28.05L650.344,939.503z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088130551544998370640000010532248556891934901_",
    gradientUnits: "userSpaceOnUse",
    x1: 590.5686,
    y1: 863.6725,
    x2: 625.5685,
    y2: 939.6724
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088130551544998370640000010532248556891934901_)"
    },
    d: "M629.229,963.417 c0.607-0.269,0.831-1.011,0.467-1.567c-1.106-1.689-3.178-5.135-3.839-8.152c0,0-2.481-1.589,6.314-3.694 c8.795-2.105,21.911-5.373,24.668-12.859c2.688-7.299-4.374-25.655-15.641-11.029c-0.429,0.556-1.268,0.568-1.697,0.012 c-1.847-2.404-6.703-7.394-13.445-4.369c-6.309,2.831-7.02,7.454-6.933,9.784c0.025,0.685-0.588,1.218-1.261,1.09 c-3.19-0.608-10.844-1.131-14.417,6.721c-2.943,6.468-1.03,10.129,0.712,11.92c0.565,0.58,0.317,1.536-0.457,1.772 c-2.096,0.642-4.803,2.419-4.532,7.331c0.375,6.79,7.966,6.192,10.128,5.882c0.354-0.051,0.711,0.071,0.951,0.336 c1.853,2.051,10.203,10.759,19.241,11.809c0.783,0.091,1.389-0.682,1.133-1.427l-3.911-11.369 c-0.182-0.528,0.071-1.107,0.582-1.334L629.229,963.417z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180338970020734090270000002213354814888030349_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.2449,
    y1: 4561.0615,
    x2: 188.7449,
    y2: 4506.0615,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 2026.8594 -1476.3188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180338970020734090270000002213354814888030349_)"
    },
    d: "M630.8,965.031 c0,0-9.826-6.741-10.544-1.064c-0.718,5.677,8.848,8.223,13.587,6.107L630.8,965.031z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1917.172,521.691l-614.542-2.954c-7.407-0.068-13.421,8.125-13.365,18.204l1.361,243.142 c0.057,10.136,6.229,18.225,13.675,17.921l611.04-13.087c7.108-0.291,12.785-8.151,12.876-17.827l2.141-227.101 C1930.453,529.969,1924.536,521.758,1917.172,521.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1303.905,782.121c-0.954,0-1.728-0.97-1.734-2.162l-1.361-243.139 c-0.003-0.574,0.149-1.078,0.454-1.495c0.422-0.577,0.932-0.698,1.285-0.698l614.545,2.954c0.352,0.004,0.855,0.131,1.273,0.711 c0.302,0.419,0.452,0.92,0.447,1.49l-2.142,227.101c-0.011,1.17-0.747,2.114-1.675,2.15h-0.008L1303.905,782.121z  M1302.546,535.627c-0.122,0-0.289,0.032-0.475,0.287c-0.175,0.241-0.263,0.544-0.261,0.9l1.361,243.139 c0.004,0.688,0.385,1.168,0.724,1.168l611.073-13.088c0.332-0.015,0.698-0.483,0.705-1.16l2.142-227.1 c0.003-0.352-0.084-0.654-0.259-0.897c-0.188-0.262-0.359-0.294-0.47-0.295L1302.546,535.627z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132068215070851054790000003779775479767074987_",
    gradientUnits: "userSpaceOnUse",
    x1: 1327.548,
    y1: 704.4745,
    x2: 1357.4548,
    y2: 704.4745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1327.548,
    y: 647.331,
    style: {
      fill: "url(#SVGID_00000132068215070851054790000003779775479767074987_)"
    },
    width: 29.907,
    height: 114.286
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065050455491319832450000013140085222791520651_",
    gradientUnits: "userSpaceOnUse",
    x1: 1377.5193,
    y1: 724.1137,
    x2: 1407.4261,
    y2: 724.1137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1377.519,
    y: 686.61,
    style: {
      fill: "url(#SVGID_00000065050455491319832450000013140085222791520651_)"
    },
    width: 29.907,
    height: 75.008
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069389291938075875590000007388805380427504551_",
    gradientUnits: "userSpaceOnUse",
    x1: 1427.4907,
    y1: 675.577,
    x2: 1457.3975,
    y2: 675.577
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1427.491,
    y: 589.536,
    style: {
      fill: "url(#SVGID_00000069389291938075875590000007388805380427504551_)"
    },
    width: 29.907,
    height: 172.081
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111881506912426188800000001462109613073275572_",
    gradientUnits: "userSpaceOnUse",
    x1: 1477.4622,
    y1: 740.9473,
    x2: 1507.369,
    y2: 740.9473
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1477.462,
    y: 720.277,
    style: {
      fill: "url(#SVGID_00000111881506912426188800000001462109613073275572_)"
    },
    width: 29.907,
    height: 41.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031925848446097334640000006930860654165914514_",
    gradientUnits: "userSpaceOnUse",
    x1: 1527.4336,
    y1: 687.0799,
    x2: 1557.3403,
    y2: 687.0799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1527.434,
    y: 612.542,
    style: {
      fill: "url(#SVGID_00000031925848446097334640000006930860654165914514_)"
    },
    width: 29.907,
    height: 149.075
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036939039630902571260000016228525492435775913_",
    gradientUnits: "userSpaceOnUse",
    x1: 1577.4049,
    y1: 699.9855,
    x2: 1607.3116,
    y2: 699.9855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1577.405,
    y: 638.354,
    style: {
      fill: "url(#SVGID_00000036939039630902571260000016228525492435775913_)"
    },
    width: 29.907,
    height: 123.264
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086658496390560170160000017304113074492641441_",
    gradientUnits: "userSpaceOnUse",
    x1: 1627.376,
    y1: 714.0135,
    x2: 1657.2827,
    y2: 714.0135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1627.376,
    y: 666.409,
    style: {
      fill: "url(#SVGID_00000086658496390560170160000017304113074492641441_)"
    },
    width: 29.907,
    height: 95.208
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011021929610081477880000012060864544918970497_",
    gradientUnits: "userSpaceOnUse",
    x1: 1677.3475,
    y1: 658.1823,
    x2: 1707.2543,
    y2: 658.1823
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1677.348,
    y: 554.747,
    style: {
      fill: "url(#SVGID_00000011021929610081477880000012060864544918970497_)"
    },
    width: 29.907,
    height: 206.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013894298135147319720000016005652967077205632_",
    gradientUnits: "userSpaceOnUse",
    x1: 1727.3188,
    y1: 669.124,
    x2: 1757.2256,
    y2: 669.124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1727.319,
    y: 576.631,
    style: {
      fill: "url(#SVGID_00000013894298135147319720000016005652967077205632_)"
    },
    width: 29.907,
    height: 184.987
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068672566859108257260000006016936770956089237_",
    gradientUnits: "userSpaceOnUse",
    x1: 1777.2902,
    y1: 685.6771,
    x2: 1807.1969,
    y2: 685.6771
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1777.29,
    y: 609.737,
    style: {
      fill: "url(#SVGID_00000068672566859108257260000006016936770956089237_)"
    },
    width: 29.907,
    height: 151.881
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009580805621603613300000012695653557550719878_",
    gradientUnits: "userSpaceOnUse",
    x1: 1827.2615,
    y1: 742.8655,
    x2: 1857.1683,
    y2: 742.8655
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1827.261,
    y: 724.114,
    style: {
      fill: "url(#SVGID_00000009580805621603613300000012695653557550719878_)"
    },
    width: 29.907,
    height: 37.504
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054944283194149959290000006711284782711085491_",
    gradientUnits: "userSpaceOnUse",
    x1: 1877.2332,
    y1: 706.4385,
    x2: 1907.1398,
    y2: 706.4385
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1877.233,
    y: 651.259,
    style: {
      fill: "url(#SVGID_00000054944283194149959290000006711284782711085491_)"
    },
    width: 29.907,
    height: 110.358
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065033624057429526680000018204063326736986543_",
    gradientUnits: "userSpaceOnUse",
    x1: 1134.4124,
    y1: 362.6845,
    x2: 371.3279,
    y2: 514.0395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065033624057429526680000018204063326736986543_)"
    },
    d: "M1168.033,452.045 c-5.878-22.54-22.122-59.104-66.064-64.566c-58.41-7.26-511.633-11.612-593.079-12.339c-7.293-0.065-13.515,5.233-14.607,12.444 c-3.001,19.808-7.785,59.486-4.162,92.735c0.834,7.652,7.398,13.379,15.091,13.107l649.189-22.973 C1163.804,470.12,1170.407,461.151,1168.033,452.045z M1135.111,450.101l-610.609,21.606 c-7.889,0.279-14.536-5.952-14.646-13.845c-0.23-16.435,1.041-33.23,2.594-47.195c0.914-8.216,7.889-14.401,16.155-14.323 c241.022,2.252,527.841,6.661,570.77,11.999c21.877,2.718,34.568,16.439,41.93,31.482 C1143.578,444.469,1140.279,449.918,1135.111,450.101z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125603074267020496660000006594157246823089042_",
    gradientUnits: "userSpaceOnUse",
    x1: 588.325,
    y1: 463.0969,
    x2: 834.3125,
    y2: 311.6045
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125603074267020496660000006594157246823089042_)"
    },
    d: "M524.601,373.724 c0.048,29.535,0.514,101.143,3.773,138.554c0.602,6.91,6.427,12.181,13.363,12.139c34.177-0.205,132.41-1.349,178.398-7.715 c5.966-0.826,10.604-5.586,11.345-11.564c3.123-25.204,10.152-92.249,1.753-128.296c-1.364-5.856-6.386-10.118-12.393-10.397 c-31.252-1.449-133.065-5.991-182.893-6.078C530.568,360.355,524.589,366.345,524.601,373.724z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038393446767034836440000002886937895408095914_",
    gradientUnits: "userSpaceOnUse",
    x1: 838.1251,
    y1: 222.8887,
    x2: 694.1326,
    y2: 366.8812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038393446767034836440000002886937895408095914_)"
    },
    d: "M566.284,384.366l3.273,103.541 c0.246,7.789,6.738,13.917,14.528,13.715l88.793-2.305c7.679-0.199,13.8-6.481,13.8-14.163v-96.551 c0-7.544-5.913-13.766-13.447-14.149l-92.066-4.686C572.891,369.348,566.022,376.085,566.284,384.366z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1087.158,
    y: 442.393,
    style: {
      fill: "#BDD0FB"
    },
    width: 8.409,
    height: 256.527
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1011.283,
    y: 565.167,
    transform: "matrix(0.0034 -1 1 0.0034 567.584 1708.2611)",
    style: {
      fill: "#BDD0FB"
    },
    width: 259.099,
    height: 8.409
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023249844428953087180000006356515084117358992_",
    gradientUnits: "userSpaceOnUse",
    x1: 1086.3538,
    y1: 704.5867,
    x2: 1146.5244,
    y2: 704.5867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000023249844428953087180000006356515084117358992_)"
    },
    cx: 1116.439,
    cy: 704.587,
    r: 30.085
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7D97F4"
    },
    cx: 1116.439,
    cy: 704.586,
    r: 17.869
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1095.776,814.016l-10.301-56.195c-2.154-11.752,6.87-22.581,18.818-22.581h25.595 c12.979,0,23.208,11.057,22.199,23.997l-4.504,57.804c-0.596,7.644-4.501,14.594-10.608,19.231 c-9.304,7.064-22.455,21.729-25.315,49.302c-4.529,43.664,36.465,58.315,61.692,53.618c19.688-3.666,30.396-27.422,26.162-45.21 c-1.576-6.617,3.21-13.016,10.012-13.016l0,0c4.753,0,8.896,3.219,10.052,7.83c4.945,19.718,11.351,70.562-50.307,80.55 c-73.013,11.827-143.841-65.99-81.432-128.931C1094.684,833.51,1097.529,823.58,1095.776,814.016z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163033336232008106460000012848852633216332420_",
    gradientUnits: "userSpaceOnUse",
    x1: 1086.3538,
    y1: 437.9965,
    x2: 1146.5244,
    y2: 437.9965
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000163033336232008106460000012848852633216332420_)"
    },
    cx: 1116.439,
    cy: 437.996,
    r: 30.085
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7D97F4"
    },
    cx: 1116.439,
    cy: 437.996,
    r: 17.869
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1631.491,453.076l-103.625,10.916c-12.817,1.35-23.981-8.699-23.981-21.587v-119.61 c0-10.793,7.93-19.947,18.613-21.485l103.625-14.92c13.085-1.884,24.8,8.266,24.8,21.485v123.614 C1650.924,442.597,1642.538,451.913,1631.491,453.076z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143579508008200578620000007370058835530054561_",
    gradientUnits: "userSpaceOnUse",
    x1: 1532.3009,
    y1: 415.4655,
    x2: 1563.0293,
    y2: 415.4655
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143579508008200578620000007370058835530054561_)"
    },
    d: "M1547.665,430.83 c-8.471,0-15.364-6.893-15.364-15.364c0-8.471,6.893-15.364,15.364-15.364c8.471,0,15.364,6.893,15.364,15.364 C1563.029,423.936,1556.136,430.83,1547.665,430.83z M1547.665,406.199c-5.109,0-9.266,4.157-9.266,9.266 c0,5.109,4.157,9.266,9.266,9.266c5.11,0,9.266-4.157,9.266-9.266C1556.931,410.356,1552.775,406.199,1547.665,406.199z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146483603423007332990000018309096815978931897_",
    gradientUnits: "userSpaceOnUse",
    x1: 1540.5226,
    y1: 397.413,
    x2: 1589.5889,
    y2: 397.413
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146483603423007332990000018309096815978931897_)"
    },
    d: "M1547.665,382.689 c18.074,0,32.777,14.703,32.777,32.777c0,1.12-0.061,2.225-0.176,3.315c-0.154,1.467,1.08,2.696,2.539,2.478l4.77-0.712 c1.042-0.155,1.822-1.019,1.9-2.069c0.074-0.995,0.114-1.999,0.114-3.012c0-23.116-18.808-41.924-41.924-41.924 c-1.751,0-3.476,0.114-5.17,0.327c-1.269,0.16-2.155,1.336-1.941,2.596l0.789,4.637c0.199,1.173,1.282,1.978,2.463,1.832 C1545.071,382.776,1546.358,382.689,1547.665,382.689z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031895733985441167790000008120481083530225048_",
    gradientUnits: "userSpaceOnUse",
    x1: 1536.556,
    y1: 383.8209,
    x2: 1613.215,
    y2: 383.8209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031895733985441167790000008120481083530225048_)"
    },
    d: "M1547.665,359.059 c31.104,0,56.406,25.303,56.406,56.407v0.026c0,1.361,1.186,2.414,2.532,2.213l4.679-0.699c0.73-0.845,1.201-1.39,1.932-2.235 c-0.374-35.827-29.636-64.859-65.55-64.859c-3.135,0-6.215,0.234-9.232,0.666c-1.227,0.176-2.053,1.353-1.845,2.576 l0.787,4.625c0.2,1.177,1.294,2.002,2.477,1.835C1542.406,359.253,1545.013,359.059,1547.665,359.059z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150066326637937121470000003784393323933674651_",
    gradientUnits: "userSpaceOnUse",
    x1: 1532.5939,
    y1: 370.247,
    x2: 1636.7203,
    y2: 370.247
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150066326637937121470000003784393323933674651_)"
    },
    d: "M1547.665,335.429 c42.984,0,78.146,34.065,79.946,76.614c0.056,1.336,1.232,2.341,2.555,2.143l4.643-0.694c1.127-0.168,1.964-1.162,1.909-2.301 c-2.24-47.196-41.312-84.91-89.053-84.91c-4.484,0-8.886,0.352-13.193,1c-1.228,0.185-2.054,1.361-1.846,2.585l0.786,4.619 c0.205,1.204,1.337,2.001,2.546,1.821C1539.78,335.738,1543.687,335.429,1547.665,335.429z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1746.537,252.696l5.008-0.178c0.552-0.02,1.014,0.412,1.034,0.963 c0.02,0.551-0.412,1.014-0.963,1.034l-0.01,0l-4.978,0.178l-0.02,0.001c-0.552,0.02-1.015-0.412-1.035-0.964 C1745.553,253.179,1745.985,252.715,1746.537,252.696L1746.537,252.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1756.546,252.386l5.001-0.101c0.551-0.011,1.006,0.427,1.017,0.977 c0.011,0.551-0.426,1.006-0.977,1.018h-0.005l-4.99,0.103h-0.006c-0.551,0.011-1.007-0.426-1.018-0.978 C1755.557,252.853,1755.995,252.397,1756.546,252.386L1756.546,252.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1766.549,252.211l5.002-0.049c0.55-0.005,1,0.436,1.005,0.986c0.005,0.55-0.44,1-0.99,1.005 l-4.992,0.05c-0.55,0.008-1.003-0.431-1.011-0.981c-0.008-0.55,0.431-1.003,0.981-1.011H1766.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1776.553,252.137l5.001-0.003c0.549,0,0.994,0.444,0.995,0.994c0,0.549-0.448,0.994-0.997,0.994 l-4.993,0.005c-0.549,0.003-0.997-0.441-1-0.99c-0.003-0.549,0.44-0.997,0.989-1H1776.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1786.554,252.152l5.002,0.039c0.548,0.004,0.989,0.452,0.984,1 c-0.004,0.548-0.456,0.989-1.004,0.984l-4.993-0.037c-0.548-0.002-0.992-0.448-0.99-0.997c0.002-0.548,0.448-0.991,0.996-0.99 L1786.554,252.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1796.555,252.251l5,0.08c0.547,0.009,0.983,0.459,0.975,1.006 c-0.009,0.547-0.463,0.983-1.01,0.975l-4.993-0.078c-0.547-0.006-0.986-0.455-0.98-1.002c0.006-0.548,0.455-0.986,1.003-0.98 H1796.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1806.557,252.429l4.998,0.119c0.546,0.013,0.978,0.466,0.965,1.012 c-0.013,0.546-0.469,0.978-1.015,0.965l-4.99-0.117c-0.546-0.011-0.981-0.462-0.97-1.009c0.011-0.546,0.462-0.981,1.009-0.97 H1806.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1816.553,252.687l4.999,0.158c0.545,0.018,0.973,0.473,0.955,1.018 c-0.017,0.544-0.476,0.972-1.021,0.955l-4.992-0.156c-0.545-0.015-0.975-0.469-0.96-1.015c0.015-0.545,0.469-0.976,1.014-0.961 H1816.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1826.552,253.023l4.999,0.198c0.544,0.021,0.967,0.479,0.946,1.023 c-0.021,0.544-0.483,0.967-1.027,0.946l-4.991-0.195c-0.544-0.02-0.97-0.476-0.951-1.02c0.019-0.544,0.476-0.97,1.02-0.951 H1826.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1836.546,253.438l4.996,0.236c0.543,0.025,0.962,0.486,0.936,1.029 c-0.026,0.542-0.49,0.961-1.032,0.936l-4.988-0.234c-0.543-0.023-0.964-0.482-0.941-1.025c0.023-0.543,0.483-0.965,1.026-0.941 L1836.546,253.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1846.537,253.93l4.995,0.276c0.541,0.03,0.956,0.493,0.926,1.035 c-0.03,0.541-0.497,0.956-1.038,0.926l-4.987-0.274c-0.542-0.028-0.959-0.489-0.931-1.031c0.028-0.542,0.489-0.959,1.031-0.932 L1846.537,253.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1856.526,254.502l4.993,0.316c0.54,0.034,0.95,0.5,0.916,1.04 c-0.034,0.54-0.504,0.95-1.044,0.916l-4.986-0.314c-0.541-0.032-0.953-0.496-0.921-1.037c0.032-0.54,0.496-0.953,1.037-0.921 L1856.526,254.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1866.508,255.155l4.988,0.357c0.539,0.039,0.944,0.507,0.906,1.046 c-0.039,0.539-0.51,0.944-1.049,0.905l-4.98-0.355c-0.54-0.036-0.948-0.503-0.911-1.042c0.036-0.54,0.503-0.948,1.042-0.912 L1866.508,255.155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1876.484,255.89l4.987,0.399c0.538,0.043,0.938,0.514,0.896,1.051 c-0.043,0.538-0.517,0.939-1.055,0.896l-4.979-0.396c-0.538-0.041-0.942-0.51-0.901-1.048c0.041-0.538,0.51-0.942,1.048-0.901 H1876.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1886.456,256.71l4.984,0.442c0.536,0.048,0.932,0.521,0.885,1.057 c-0.047,0.536-0.525,0.932-1.061,0.885l-4.976-0.439c-0.537-0.045-0.936-0.517-0.891-1.054c0.045-0.537,0.517-0.936,1.054-0.891 L1886.456,256.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1896.422,257.615l4.98,0.486c0.535,0.052,0.926,0.528,0.874,1.063 c-0.052,0.535-0.532,0.926-1.067,0.874l-4.972-0.483c-0.536-0.05-0.929-0.524-0.88-1.06c0.05-0.536,0.524-0.93,1.06-0.88 L1896.422,257.615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1906.376,258.609l4.973,0.531c0.533,0.057,0.92,0.536,0.863,1.069 c-0.057,0.533-0.54,0.919-1.073,0.862l-4.964-0.528c-0.534-0.055-0.923-0.532-0.869-1.066c0.054-0.534,0.531-0.923,1.066-0.869 L1906.376,258.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1916.321,259.694l4.97,0.578c0.532,0.061,0.913,0.543,0.851,1.075 c-0.062,0.532-0.547,0.913-1.079,0.851l-4.961-0.575c-0.533-0.059-0.917-0.539-0.857-1.072c0.059-0.533,0.539-0.917,1.072-0.857 L1916.321,259.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1926.26,260.874l4.965,0.626c0.53,0.067,0.906,0.551,0.839,1.081 c-0.067,0.53-0.555,0.905-1.086,0.838l-4.956-0.623c-0.531-0.064-0.91-0.547-0.846-1.078c0.064-0.531,0.547-0.91,1.078-0.846 L1926.26,260.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1936.188,262.151l4.959,0.676c0.529,0.072,0.899,0.559,0.827,1.088 c-0.072,0.528-0.564,0.898-1.092,0.826l-4.949-0.673c-0.53-0.069-0.903-0.555-0.833-1.085c0.069-0.529,0.555-0.902,1.084-0.833 L1936.188,262.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1946.102,263.529l4.952,0.728c0.527,0.078,0.891,0.567,0.814,1.094 c-0.078,0.527-0.568,0.892-1.094,0.814l-0.005-0.001l-4.942-0.725l-0.005-0.001c-0.527-0.077-0.892-0.567-0.815-1.095 C1945.084,263.816,1945.574,263.452,1946.102,263.529L1946.102,263.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1956.002,265.012l4.944,0.783c0.525,0.083,0.883,0.576,0.8,1.101 c-0.083,0.525-0.576,0.883-1.101,0.8l-0.005-0.001l-4.933-0.779l-0.005-0.001c-0.526-0.083-0.884-0.576-0.801-1.102 C1954.982,265.288,1955.476,264.929,1956.002,265.012L1956.002,265.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1965.885,266.605l4.935,0.838c0.523,0.089,0.875,0.585,0.786,1.108 c-0.089,0.523-0.585,0.875-1.108,0.786l-0.005,0l-4.924-0.835l-0.005-0.001c-0.524-0.088-0.876-0.585-0.787-1.109 C1964.864,266.869,1965.361,266.516,1965.885,266.605L1965.885,266.605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1975.749,268.311l4.925,0.898c0.521,0.095,0.867,0.594,0.772,1.115 c-0.095,0.521-0.594,0.867-1.115,0.772l-0.005-0.001l-4.913-0.893l-0.006-0.001c-0.522-0.095-0.867-0.595-0.773-1.116 C1974.727,268.563,1975.227,268.216,1975.749,268.311L1975.749,268.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1985.593,270.137l4.913,0.959c0.519,0.102,0.857,0.604,0.756,1.123 c-0.101,0.519-0.604,0.857-1.123,0.756l-0.006-0.001l-4.902-0.955l-0.006-0.001c-0.519-0.101-0.858-0.604-0.757-1.124 C1984.57,270.375,1985.073,270.036,1985.593,270.137L1985.593,270.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1995.413,272.087l4.901,1.023c0.517,0.108,0.848,0.614,0.74,1.131s-0.614,0.848-1.131,0.74 l-0.006-0.001l-4.888-1.02l-0.006-0.001c-0.517-0.108-0.849-0.615-0.741-1.132 C1994.389,272.31,1994.896,271.979,1995.413,272.087L1995.413,272.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2005.208,274.168l4.886,1.091c0.514,0.115,0.838,0.625,0.723,1.139 c-0.115,0.514-0.625,0.838-1.139,0.723l-0.006-0.001l-4.874-1.087l-0.007-0.001c-0.515-0.115-0.839-0.625-0.724-1.14 C2004.183,274.376,2004.693,274.052,2005.208,274.168L2005.208,274.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2014.973,276.385l4.87,1.163c0.511,0.122,0.827,0.636,0.705,1.147 c-0.122,0.511-0.636,0.827-1.147,0.705l-0.007-0.002l-4.857-1.157l-0.007-0.002c-0.512-0.122-0.828-0.636-0.706-1.148 C2013.947,276.579,2014.461,276.263,2014.973,276.385L2014.973,276.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2024.705,278.747l4.852,1.238c0.509,0.129,0.816,0.647,0.686,1.156 c-0.13,0.508-0.647,0.815-1.156,0.686l-0.007-0.002l-4.838-1.232l-0.007-0.001c-0.509-0.13-0.817-0.647-0.687-1.157 C2023.678,278.925,2024.196,278.617,2024.705,278.747L2024.705,278.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2034.4,281.261l4.832,1.317c0.505,0.138,0.804,0.659,0.666,1.165 c-0.138,0.506-0.659,0.804-1.165,0.666l-0.007-0.002l-4.817-1.311l-0.008-0.002c-0.506-0.138-0.805-0.66-0.667-1.166 C2033.372,281.422,2033.894,281.124,2034.4,281.261L2034.4,281.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2044.053,283.936l4.809,1.4c0.502,0.146,0.791,0.672,0.645,1.174 c-0.146,0.503-0.672,0.791-1.174,0.645l-0.008-0.003l-4.793-1.394l-0.008-0.003c-0.503-0.146-0.792-0.672-0.645-1.175 C2043.024,284.079,2043.55,283.79,2044.053,283.936L2044.053,283.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2053.658,286.781l4.783,1.49c0.499,0.155,0.777,0.685,0.622,1.183 c-0.155,0.499-0.685,0.777-1.183,0.622l-0.009-0.003l-4.766-1.482l-0.009-0.003c-0.499-0.155-0.778-0.686-0.622-1.184 C2052.628,286.905,2053.159,286.626,2053.658,286.781L2053.658,286.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2063.209,289.807l4.753,1.584c0.494,0.165,0.761,0.699,0.597,1.193 c-0.165,0.495-0.699,0.762-1.193,0.597l-0.009-0.003l-4.736-1.576l-0.009-0.003c-0.495-0.164-0.762-0.699-0.598-1.194 C2062.179,289.91,2062.714,289.642,2063.209,289.807L2063.209,289.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2072.699,293.023l4.719,1.684c0.49,0.174,0.745,0.713,0.571,1.203 c-0.175,0.49-0.714,0.745-1.203,0.57l-0.01-0.003l-4.7-1.675l-0.01-0.003c-0.49-0.175-0.746-0.714-0.571-1.204 C2071.669,293.104,2072.208,292.849,2072.699,293.023L2072.699,293.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2082.119,296.444l4.681,1.791c0.485,0.185,0.728,0.728,0.542,1.213 c-0.185,0.485-0.729,0.727-1.214,0.542l-0.01-0.004l-4.661-1.781l-0.01-0.004c-0.485-0.186-0.729-0.729-0.543-1.215 C2081.09,296.501,2081.634,296.258,2082.119,296.444L2082.119,296.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2091.459,300.081l4.636,1.904c0.479,0.197,0.708,0.745,0.511,1.224 c-0.197,0.479-0.745,0.708-1.224,0.511l-0.011-0.004l-4.615-1.893l-0.011-0.004c-0.48-0.197-0.709-0.745-0.512-1.225 S2090.979,299.884,2091.459,300.081L2091.459,300.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2100.708,303.949l4.586,2.025c0.473,0.209,0.687,0.762,0.478,1.235 c-0.209,0.473-0.762,0.688-1.235,0.478l-0.011-0.005l-4.563-2.014l-0.011-0.005c-0.474-0.209-0.688-0.762-0.479-1.236 C2099.68,303.954,2100.234,303.74,2100.708,303.949L2100.708,303.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2109.851,308.064l4.527,2.155c0.466,0.222,0.664,0.779,0.442,1.246 c-0.222,0.466-0.78,0.664-1.246,0.442l-0.012-0.006l-4.503-2.142l-0.012-0.006c-0.467-0.222-0.665-0.78-0.443-1.247 C2108.826,308.04,2109.384,307.841,2109.851,308.064L2109.851,308.064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2118.873,312.442l4.46,2.294c0.458,0.235,0.638,0.798,0.403,1.256 c-0.236,0.458-0.798,0.638-1.256,0.403l-0.013-0.007l-4.434-2.278l-0.013-0.007c-0.459-0.236-0.639-0.799-0.404-1.257 C2117.851,312.387,2118.414,312.206,2118.873,312.442L2118.873,312.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2127.756,317.102l4.382,2.442c0.449,0.25,0.61,0.817,0.36,1.267 c-0.25,0.449-0.817,0.61-1.267,0.36l-0.014-0.008l-4.354-2.425l-0.014-0.008c-0.45-0.25-0.611-0.818-0.361-1.268 C2126.738,317.013,2127.305,316.852,2127.756,317.102L2127.756,317.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2136.476,322.063l4.292,2.6c0.439,0.266,0.579,0.837,0.313,1.276 c-0.266,0.439-0.838,0.579-1.277,0.313l-0.015-0.009l-4.263-2.58l-0.015-0.009c-0.439-0.266-0.58-0.838-0.314-1.278 C2135.464,321.938,2136.036,321.797,2136.476,322.063L2136.476,322.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2145.009,327.341l4.205,2.72c0.43,0.278,0.553,0.853,0.275,1.283 c-0.278,0.43-0.853,0.554-1.283,0.275l-0.006-0.004l-4.193-2.71l-0.007-0.004c-0.431-0.278-0.554-0.853-0.276-1.284 C2144.003,327.186,2144.578,327.063,2145.009,327.341L2145.009,327.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2153.396,332.817l4.157,2.793c0.425,0.285,0.538,0.86,0.252,1.285 c-0.285,0.424-0.86,0.538-1.285,0.253l-0.007-0.005l-4.145-2.782l-0.007-0.004c-0.425-0.286-0.538-0.861-0.253-1.286 C2152.395,332.645,2152.97,332.531,2153.396,332.817L2153.396,332.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2161.685,338.44l4.105,2.87c0.418,0.293,0.52,0.869,0.228,1.287 c-0.292,0.418-0.869,0.521-1.287,0.228l-0.007-0.005l-4.091-2.858l-0.007-0.005c-0.419-0.293-0.521-0.87-0.229-1.289 C2160.689,338.25,2161.266,338.147,2161.685,338.44L2161.685,338.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2169.867,344.222l4.047,2.953c0.412,0.3,0.502,0.877,0.201,1.289 c-0.3,0.412-0.877,0.502-1.289,0.202l-0.008-0.006l-4.032-2.94l-0.008-0.005c-0.412-0.301-0.502-0.879-0.202-1.291 C2168.877,344.011,2169.455,343.921,2169.867,344.222L2169.867,344.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2177.929,350.172l3.982,3.042c0.404,0.309,0.481,0.887,0.173,1.29 c-0.309,0.404-0.887,0.481-1.291,0.173l-0.008-0.006l-3.966-3.028l-0.008-0.006c-0.405-0.309-0.482-0.887-0.173-1.292 C2176.946,349.94,2177.524,349.863,2177.929,350.172L2177.929,350.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2185.856,356.303l3.908,3.137c0.396,0.318,0.459,0.896,0.142,1.292 c-0.318,0.396-0.896,0.459-1.292,0.141l-0.009-0.007l-3.891-3.122l-0.009-0.007c-0.396-0.318-0.46-0.897-0.142-1.293 C2184.881,356.048,2185.46,355.984,2185.856,356.303L2185.856,356.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2193.633,362.627l3.825,3.239c0.386,0.327,0.435,0.906,0.107,1.293 c-0.327,0.386-0.906,0.435-1.293,0.107l-0.01-0.008l-3.807-3.222l-0.01-0.008c-0.387-0.328-0.435-0.907-0.108-1.294 C2192.666,362.348,2193.245,362.299,2193.633,362.627L2193.633,362.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2201.238,369.16l3.731,3.349c0.376,0.338,0.407,0.917,0.07,1.293 c-0.338,0.376-0.917,0.407-1.293,0.069l-0.01-0.009l-3.712-3.33l-0.01-0.009c-0.377-0.338-0.408-0.917-0.07-1.294 C2200.281,368.853,2200.861,368.822,2201.238,369.16L2201.238,369.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2208.648,375.917l3.624,3.467c0.365,0.349,0.377,0.927,0.029,1.292 c-0.349,0.365-0.927,0.377-1.292,0.028l-0.011-0.01l-3.603-3.445l-0.011-0.011c-0.365-0.349-0.378-0.928-0.029-1.293 C2207.704,375.58,2208.283,375.567,2208.648,375.917L2208.648,375.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2215.836,382.914l3.5,3.594c0.352,0.361,0.344,0.938-0.017,1.29 c-0.361,0.352-0.938,0.344-1.29-0.017l-0.012-0.012l-3.478-3.568l-0.012-0.012c-0.352-0.361-0.344-0.939,0.017-1.291 C2214.906,382.544,2215.484,382.552,2215.836,382.914L2215.836,382.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2222.768,390.169l3.357,3.73c0.336,0.373,0.306,0.949-0.068,1.286 c-0.374,0.336-0.949,0.306-1.285-0.068l-0.013-0.014l-3.333-3.701l-0.013-0.014c-0.337-0.374-0.306-0.95,0.067-1.287 C2221.855,389.765,2222.431,389.795,2222.768,390.169L2222.768,390.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2229.406,397.705l3.194,3.879c0.319,0.388,0.263,0.96-0.124,1.279 c-0.387,0.319-0.96,0.263-1.279-0.124l-0.013-0.016l-3.169-3.846l-0.013-0.016c-0.32-0.388-0.264-0.961,0.123-1.28 C2228.514,397.262,2229.087,397.317,2229.406,397.705L2229.406,397.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2235.701,405.539l3,4.033c0.299,0.402,0.215,0.97-0.186,1.269 c-0.402,0.299-0.97,0.215-1.269-0.186l-0.014-0.019l-2.973-3.994l-0.014-0.019c-0.299-0.402-0.216-0.971,0.186-1.27 C2234.833,405.053,2235.402,405.137,2235.701,405.539L2235.701,405.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2241.592,413.685l2.772,4.194c0.276,0.417,0.161,0.978-0.256,1.254 c-0.417,0.275-0.979,0.161-1.254-0.256l-0.015-0.022l-2.745-4.149l-0.014-0.022c-0.276-0.417-0.162-0.979,0.256-1.255 C2240.753,413.152,2241.315,413.267,2241.592,413.685L2241.592,413.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2247.01,422.156l2.506,4.358c0.249,0.432,0.1,0.984-0.333,1.233 c-0.432,0.249-0.985,0.1-1.233-0.333l-0.015-0.026l-2.478-4.306l-0.015-0.025c-0.249-0.433-0.1-0.985,0.333-1.234 C2246.208,421.574,2246.76,421.723,2247.01,422.156L2247.01,422.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2251.874,430.959l2.197,4.527c0.217,0.448,0.031,0.987-0.417,1.205 c-0.448,0.217-0.987,0.031-1.205-0.417l-0.015-0.03l-2.169-4.467l-0.015-0.03c-0.218-0.448-0.031-0.988,0.417-1.206 C2251.116,430.324,2251.656,430.51,2251.874,430.959L2251.874,430.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2256.094,440.095l1.837,4.686c0.181,0.463-0.046,0.985-0.509,1.167 c-0.463,0.181-0.985-0.047-1.166-0.509l-0.014-0.035l-1.812-4.616l-0.013-0.034c-0.182-0.463,0.046-0.985,0.509-1.167 C2255.39,439.403,2255.913,439.631,2256.094,440.095L2256.094,440.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2259.572,449.544l1.428,4.833c0.14,0.476-0.131,0.975-0.607,1.115 c-0.475,0.141-0.975-0.131-1.115-0.607l-0.011-0.039l-1.407-4.754l-0.011-0.039c-0.141-0.476,0.131-0.976,0.607-1.117 C2258.931,448.796,2259.431,449.068,2259.572,449.544L2259.572,449.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2262.204,459.272l0.969,4.947c0.095,0.486-0.222,0.957-0.707,1.052 c-0.486,0.095-0.957-0.222-1.052-0.707l-0.008-0.043l-0.953-4.861l-0.008-0.043c-0.095-0.486,0.221-0.957,0.708-1.053 C2261.637,458.469,2262.108,458.786,2262.204,459.272L2262.204,459.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2263.895,469.209l0.469,5.02c0.046,0.492-0.315,0.928-0.807,0.974 c-0.492,0.046-0.928-0.315-0.974-0.807l-0.004-0.045l-0.462-4.929l-0.004-0.045c-0.046-0.492,0.315-0.929,0.808-0.975 C2263.413,468.354,2263.849,468.716,2263.895,469.209L2263.895,469.209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2264.574,479.266l-0.053,5.045c-0.005,0.493-0.409,0.889-0.902,0.883 c-0.493-0.005-0.888-0.409-0.883-0.902l0-0.046l0.051-4.952l0-0.047c0.005-0.493,0.409-0.889,0.902-0.884 C2264.183,478.368,2264.579,478.772,2264.574,479.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2264.204,489.347l-0.578,5.012c-0.056,0.489-0.498,0.839-0.987,0.783 c-0.489-0.056-0.839-0.498-0.783-0.987l0.005-0.045l0.566-4.92l0.005-0.046c0.056-0.489,0.499-0.84,0.988-0.784 C2263.909,488.415,2264.26,488.857,2264.204,489.347L2264.204,489.347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2262.792,499.333l-1.083,4.925c-0.106,0.48-0.58,0.783-1.06,0.677 c-0.479-0.105-0.783-0.58-0.677-1.059l0.009-0.043l1.063-4.839l0.01-0.043c0.105-0.48,0.58-0.784,1.06-0.679 C2262.594,498.378,2262.897,498.853,2262.792,499.333L2262.792,499.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2260.386,509.124l-1.551,4.796c-0.151,0.466-0.651,0.722-1.117,0.571 c-0.466-0.151-0.722-0.651-0.571-1.118l0.012-0.038l1.524-4.718l0.013-0.04c0.151-0.467,0.651-0.723,1.118-0.572 C2260.281,508.156,2260.537,508.657,2260.386,509.124L2260.386,509.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2257.071,518.635l-1.968,4.633c-0.191,0.45-0.711,0.66-1.161,0.469 c-0.45-0.191-0.66-0.711-0.469-1.162l0.015-0.034l1.937-4.564l0.015-0.035c0.191-0.451,0.712-0.661,1.162-0.47 C2257.052,517.663,2257.262,518.184,2257.071,518.635L2257.071,518.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2252.946,527.813l-2.334,4.457c-0.226,0.432-0.761,0.6-1.193,0.373 c-0.433-0.227-0.6-0.761-0.373-1.193l0.015-0.03l2.301-4.398l0.016-0.03c0.227-0.433,0.761-0.6,1.194-0.374 C2253.005,526.846,2253.172,527.38,2252.946,527.813L2252.946,527.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2248.114,536.636l-2.649,4.274c-0.257,0.414-0.801,0.542-1.215,0.285 c-0.414-0.257-0.542-0.801-0.285-1.215l0.016-0.025l2.616-4.223l0.016-0.026c0.257-0.415,0.801-0.543,1.216-0.286 C2248.243,535.677,2248.371,536.221,2248.114,536.636L2248.114,536.636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2242.676,545.092l-2.918,4.092c-0.282,0.396-0.833,0.488-1.229,0.206 c-0.396-0.282-0.488-0.833-0.206-1.229l0.015-0.021l2.885-4.049l0.016-0.022c0.282-0.397,0.833-0.489,1.229-0.206 C2242.866,544.144,2242.959,544.695,2242.676,545.092L2242.676,545.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2236.721,553.186l-3.147,3.916c-0.304,0.378-0.857,0.438-1.236,0.134 c-0.378-0.304-0.439-0.857-0.135-1.235l0.015-0.019l3.115-3.879l0.015-0.018c0.304-0.379,0.858-0.44,1.237-0.135 C2236.965,552.253,2237.025,552.807,2236.721,553.186L2236.721,553.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2230.328,560.929l-3.339,3.746c-0.322,0.362-0.877,0.394-1.239,0.071 c-0.362-0.322-0.394-0.877-0.071-1.238l0.014-0.016l3.31-3.715l0.014-0.016c0.323-0.362,0.878-0.394,1.24-0.072 C2230.619,560.012,2230.651,560.567,2230.328,560.929L2230.328,560.929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2223.564,568.342l-3.505,3.59c-0.338,0.346-0.892,0.353-1.238,0.015 c-0.346-0.337-0.353-0.892-0.015-1.238l0.013-0.013l3.478-3.564l0.013-0.013c0.338-0.347,0.893-0.353,1.239-0.016 C2223.896,567.44,2223.902,567.995,2223.564,568.342L2223.564,568.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2216.48,575.447l-3.647,3.444c-0.351,0.331-0.904,0.315-1.235-0.036 c-0.331-0.351-0.315-0.904,0.035-1.235l0.012-0.011l3.622-3.422l0.012-0.012c0.351-0.332,0.905-0.316,1.236,0.035 C2216.847,574.562,2216.831,575.115,2216.48,575.447L2216.48,575.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2209.123,582.267l-3.766,3.306c-0.362,0.318-0.913,0.282-1.23-0.08 c-0.318-0.362-0.282-0.913,0.08-1.23l0.011-0.01l3.742-3.287l0.011-0.01c0.362-0.318,0.914-0.282,1.232,0.08 C2209.521,581.396,2209.485,581.948,2209.123,582.267L2209.123,582.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2201.534,588.815l-3.874,3.182c-0.371,0.305-0.92,0.251-1.225-0.12 c-0.305-0.371-0.251-0.919,0.12-1.225l0.01-0.008l3.852-3.166l0.01-0.009c0.372-0.305,0.921-0.252,1.226,0.12 C2201.96,587.961,2201.906,588.51,2201.534,588.815L2201.534,588.815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2193.74,595.121l-3.923,3.094c-0.375,0.299-0.921,0.238-1.22-0.137s-0.234-0.924,0.141-1.224 l3.929-3.101c0.377-0.298,0.924-0.233,1.221,0.144c0.297,0.377,0.233,0.924-0.144,1.221L2193.74,595.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2185.912,601.33l-3.886,3.138l-0.004,0.003c-0.372,0.301-0.918,0.243-1.219-0.13 c-0.301-0.372-0.243-0.918,0.13-1.219l3.894-3.146c0.373-0.301,0.919-0.243,1.22,0.129c0.301,0.373,0.243,0.919-0.13,1.22 l0,0.001L2185.912,601.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2178.159,607.63l-3.844,3.188l-0.005,0.004c-0.368,0.305-0.913,0.254-1.218-0.113 c-0.305-0.368-0.254-0.913,0.114-1.218l3.853-3.198c0.368-0.305,0.914-0.254,1.219,0.113c0.305,0.368,0.255,0.914-0.113,1.22h0 L2178.159,607.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2170.495,614.036l-3.794,3.247l-0.006,0.004c-0.362,0.31-0.907,0.268-1.217-0.095 s-0.268-0.907,0.094-1.217l3.804-3.257c0.363-0.311,0.908-0.268,1.219,0.094c0.311,0.363,0.268,0.908-0.094,1.219h0 L2170.495,614.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2162.935,620.561l-3.734,3.314l-0.006,0.005c-0.356,0.316-0.9,0.284-1.216-0.072 c-0.316-0.356-0.283-0.9,0.073-1.216l3.745-3.326c0.356-0.316,0.901-0.284,1.218,0.072c0.316,0.356,0.284,0.901-0.072,1.218l0,0 L2162.935,620.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2155.501,627.225l-3.661,3.392l-0.008,0.007c-0.348,0.323-0.892,0.302-1.215-0.046 c-0.323-0.349-0.302-0.892,0.046-1.215l3.675-3.406c0.349-0.323,0.893-0.303,1.217,0.046c0.323,0.349,0.302,0.893-0.046,1.216v0 L2155.501,627.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2148.221,634.052l-3.572,3.483l-0.009,0.008c-0.339,0.331-0.883,0.324-1.213-0.015 c-0.331-0.339-0.324-0.882,0.015-1.213l3.588-3.5c0.34-0.332,0.884-0.325,1.215,0.015c0.331,0.34,0.324,0.883-0.015,1.215h0 L2148.221,634.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2141.13,641.069l-3.46,3.59l-0.01,0.011c-0.328,0.341-0.87,0.351-1.211,0.023 c-0.34-0.328-0.351-0.87-0.022-1.211l3.479-3.613c0.329-0.341,0.871-0.351,1.212-0.023c0.341,0.328,0.351,0.871,0.023,1.212h0 L2141.13,641.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2134.276,648.31l-3.318,3.717l-0.012,0.014c-0.314,0.353-0.854,0.383-1.207,0.069 c-0.352-0.314-0.383-0.854-0.069-1.207l3.341-3.746c0.314-0.353,0.855-0.383,1.208-0.069c0.353,0.314,0.384,0.855,0.069,1.208h0 L2134.276,648.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2127.727,655.816l-3.134,3.868l-0.015,0.018c-0.296,0.366-0.833,0.422-1.199,0.125 c-0.366-0.296-0.423-0.833-0.126-1.199l3.161-3.904c0.297-0.366,0.834-0.423,1.201-0.126c0.366,0.296,0.423,0.834,0.126,1.201h0 L2127.727,655.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2121.572,663.637l-2.891,4.045l-0.017,0.024c-0.273,0.382-0.805,0.471-1.187,0.197 c-0.382-0.273-0.471-0.804-0.198-1.187l2.923-4.093c0.273-0.383,0.805-0.471,1.188-0.198c0.383,0.273,0.472,0.805,0.198,1.188 l0,0L2121.572,663.637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2115.94,671.825l-2.567,4.248l-0.02,0.032c-0.242,0.401-0.764,0.53-1.166,0.288 c-0.401-0.242-0.53-0.764-0.288-1.165l2.604-4.312c0.243-0.402,0.765-0.531,1.167-0.288c0.402,0.243,0.531,0.765,0.288,1.167 l0,0L2115.94,671.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2111.007,680.431l-2.135,4.47l-0.02,0.043c-0.202,0.422-0.708,0.602-1.13,0.4 c-0.422-0.202-0.601-0.708-0.399-1.13l2.173-4.555c0.202-0.423,0.708-0.602,1.131-0.4c0.423,0.202,0.602,0.708,0.4,1.131v0 L2111.007,680.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2107.001,689.484l-1.57,4.685l-0.018,0.055c-0.148,0.442-0.627,0.681-1.07,0.533 c-0.443-0.148-0.681-0.627-0.533-1.07l1.605-4.793c0.148-0.443,0.628-0.683,1.071-0.534c0.443,0.148,0.682,0.628,0.534,1.071v0 L2107.001,689.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2104.191,698.949l-0.882,4.853l-0.011,0.063c-0.083,0.458-0.522,0.763-0.981,0.679 c-0.458-0.083-0.762-0.522-0.679-0.98l0.903-4.979c0.083-0.459,0.523-0.763,0.982-0.68c0.459,0.083,0.763,0.523,0.68,0.982l0,0 L2104.191,698.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2102.8,708.71l-0.132,4.933l-0.002,0.064c-0.012,0.464-0.399,0.831-0.864,0.819 c-0.465-0.012-0.832-0.399-0.819-0.864l0.133-5.061c0.012-0.465,0.399-0.833,0.865-0.82c0.465,0.013,0.833,0.399,0.82,0.865v0 L2102.8,708.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2102.904,718.576l0.579,4.908l0.006,0.055c0.054,0.461-0.275,0.878-0.736,0.933 c-0.461,0.054-0.878-0.275-0.933-0.736l-0.593-5.019c-0.055-0.461,0.275-0.879,0.737-0.934c0.461-0.055,0.879,0.275,0.934,0.736 v0L2102.904,718.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2104.372,728.351l1.164,4.816l0.01,0.042c0.109,0.45-0.168,0.903-0.618,1.012 s-0.903-0.168-1.012-0.618l-1.186-4.901c-0.109-0.451,0.168-0.905,0.619-1.014c0.45-0.109,0.904,0.168,1.013,0.619h0 L2104.372,728.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2106.935,737.927l1.597,4.704l0.01,0.029c0.149,0.438-0.086,0.913-0.523,1.061 c-0.438,0.149-0.913-0.085-1.062-0.523l-1.619-4.764c-0.149-0.438,0.085-0.914,0.523-1.063c0.438-0.149,0.914,0.085,1.063,0.523 v0L2106.935,737.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2110.292,747.278l1.895,4.601l0.008,0.019c0.176,0.427-0.028,0.915-0.454,1.091 c-0.427,0.176-0.915-0.027-1.091-0.454l-1.913-4.64c-0.176-0.427,0.027-0.916,0.454-1.092c0.427-0.176,0.916,0.027,1.092,0.455 h0L2110.292,747.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2114.19,756.439l2.089,4.527l0.005,0.012c0.193,0.418,0.01,0.914-0.408,1.107 c-0.418,0.193-0.913,0.011-1.106-0.408l-2.102-4.551c-0.193-0.419-0.011-0.914,0.408-1.107c0.418-0.193,0.914-0.011,1.107,0.408 l0,0L2114.19,756.439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2118.434,765.466l2.202,4.476l0.003,0.006c0.203,0.412,0.033,0.911-0.379,1.114 c-0.412,0.203-0.911,0.033-1.114-0.379l-2.21-4.488c-0.203-0.413-0.033-0.912,0.379-1.115s0.912-0.033,1.115,0.379h0 L2118.434,765.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2122.874,774.405l2.262,4.456c0.209,0.408,0.047,0.908-0.361,1.117 c-0.408,0.209-0.91,0.045-1.119-0.363l-2.266-4.46c-0.208-0.409-0.045-0.91,0.365-1.118c0.409-0.208,0.91-0.044,1.118,0.365 L2122.874,774.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2127.371,783.358l2.039,4.601c0.185,0.418-0.003,0.908-0.422,1.093 c-0.418,0.185-0.908-0.004-1.093-0.421l-0.014-0.032l-2.011-4.535l-0.015-0.034c-0.186-0.418,0.003-0.908,0.422-1.094 C2126.695,782.75,2127.185,782.94,2127.371,783.358L2127.371,783.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2131.262,792.632l1.689,4.73c0.153,0.43-0.071,0.903-0.501,1.057 c-0.43,0.154-0.903-0.07-1.056-0.5l-0.009-0.024l-1.673-4.679l-0.009-0.025c-0.154-0.431,0.07-0.904,0.501-1.058 S2131.108,792.201,2131.262,792.632L2131.262,792.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2134.493,802.142l1.402,4.819c0.127,0.438-0.124,0.896-0.562,1.023 c-0.438,0.127-0.896-0.125-1.023-0.562l-0.006-0.021l-1.391-4.774l-0.007-0.022c-0.127-0.438,0.124-0.897,0.562-1.024 C2133.907,801.452,2134.365,801.704,2134.493,802.142L2134.493,802.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2137.166,811.816l1.146,4.886c0.104,0.443-0.171,0.886-0.614,0.989 c-0.443,0.104-0.885-0.171-0.989-0.613l-0.005-0.02l-1.138-4.845l-0.005-0.021c-0.104-0.443,0.171-0.887,0.614-0.991 S2137.062,811.373,2137.166,811.816L2137.166,811.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2139.334,821.613l0.904,4.935c0.082,0.446-0.214,0.874-0.66,0.956 c-0.446,0.082-0.874-0.214-0.956-0.66l-0.003-0.019l-0.898-4.896l-0.004-0.019c-0.082-0.447,0.214-0.876,0.66-0.958 C2138.824,820.87,2139.253,821.166,2139.334,821.613L2139.334,821.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2141.025,831.502l0.671,4.972c0.061,0.449-0.254,0.861-0.703,0.922 c-0.449,0.06-0.861-0.254-0.922-0.703l-0.002-0.019l-0.668-4.934l-0.002-0.018c-0.061-0.449,0.254-0.863,0.703-0.923 C2140.551,830.738,2140.964,831.053,2141.025,831.502L2141.025,831.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2142.251,841.458l0.442,4.995c0.04,0.45-0.293,0.847-0.743,0.887 c-0.45,0.04-0.847-0.293-0.887-0.743l-0.002-0.018l-0.44-4.958l-0.001-0.018c-0.04-0.451,0.293-0.848,0.743-0.888 C2141.814,840.674,2142.211,841.007,2142.251,841.458L2142.251,841.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2143.021,851.457l0.214,5.011c0.019,0.45-0.33,0.831-0.781,0.85 c-0.45,0.019-0.831-0.33-0.85-0.781l-0.001-0.018l-0.214-4.974l-0.001-0.019c-0.02-0.451,0.33-0.832,0.781-0.852 C2142.62,850.656,2143.001,851.006,2143.021,851.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2143.335,861.483l-0.013,5.016c-0.001,0.45-0.367,0.813-0.817,0.813 c-0.45-0.001-0.813-0.367-0.812-0.817v-0.018l0.011-4.979v-0.019c0.001-0.451,0.367-0.814,0.817-0.813 C2142.972,860.667,2143.336,861.032,2143.335,861.483L2143.335,861.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2143.195,871.514l-0.242,5.011c-0.022,0.448-0.403,0.794-0.851,0.773 c-0.448-0.022-0.794-0.403-0.773-0.851l0.001-0.018l0.238-4.974l0.001-0.019c0.021-0.449,0.403-0.795,0.852-0.773 C2142.87,870.684,2143.216,871.065,2143.195,871.514L2143.195,871.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2142.597,881.529l-0.471,4.995c-0.042,0.446-0.438,0.773-0.884,0.731 c-0.446-0.042-0.773-0.438-0.731-0.883l0.002-0.019l0.466-4.958l0.002-0.019c0.042-0.446,0.438-0.774,0.884-0.733 C2142.311,880.686,2142.639,881.082,2142.597,881.529L2142.597,881.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2141.54,891.503l-0.701,4.965c-0.062,0.442-0.472,0.75-0.914,0.688 c-0.443-0.062-0.751-0.472-0.688-0.914l0.003-0.019l0.694-4.928l0.003-0.019c0.062-0.443,0.472-0.752,0.915-0.689 C2141.294,890.65,2141.603,891.06,2141.54,891.503L2141.54,891.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2140.023,901.417l-0.931,4.928c-0.083,0.439-0.505,0.727-0.943,0.644 c-0.438-0.083-0.727-0.505-0.644-0.943l0.003-0.018l0.923-4.891l0.003-0.019c0.083-0.439,0.506-0.727,0.944-0.644 C2139.818,900.555,2140.106,900.977,2140.023,901.417L2140.023,901.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2138.046,911.25l-1.161,4.879c-0.103,0.433-0.538,0.7-0.971,0.597 c-0.433-0.103-0.7-0.538-0.597-0.971l0.004-0.018l1.151-4.843l0.004-0.018c0.103-0.434,0.538-0.701,0.971-0.598 C2137.881,910.381,2138.149,910.816,2138.046,911.25L2138.046,911.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2135.608,920.979l-1.39,4.819c-0.123,0.427-0.569,0.673-0.995,0.55 c-0.427-0.123-0.673-0.569-0.55-0.995l0.005-0.018l1.378-4.784l0.005-0.018c0.123-0.427,0.569-0.674,0.996-0.551 C2135.485,920.106,2135.731,920.552,2135.608,920.979L2135.608,920.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2132.714,930.584l-1.616,4.749c-0.143,0.419-0.599,0.644-1.018,0.501 c-0.419-0.143-0.644-0.599-0.501-1.018l0.006-0.018l1.603-4.713l0.006-0.018c0.143-0.42,0.599-0.644,1.019-0.501 C2132.632,929.708,2132.857,930.164,2132.714,930.584L2132.714,930.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2129.369,940.042l-1.839,4.668c-0.162,0.412-0.627,0.614-1.038,0.452s-0.613-0.627-0.451-1.039 l0.007-0.017l1.823-4.633l0.007-0.017c0.162-0.412,0.627-0.615,1.039-0.453C2129.329,939.165,2129.532,939.63,2129.369,940.042 L2129.369,940.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2125.582,949.333l-2.056,4.576c-0.181,0.402-0.654,0.582-1.056,0.401 c-0.402-0.181-0.582-0.653-0.401-1.056l0.008-0.017l2.039-4.542l0.008-0.017c0.181-0.403,0.654-0.583,1.057-0.402 C2125.583,948.456,2125.763,948.93,2125.582,949.333L2125.582,949.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2121.364,958.435l-2.267,4.476c-0.199,0.393-0.679,0.55-1.071,0.351 c-0.393-0.199-0.55-0.679-0.351-1.071l0.008-0.016l2.249-4.443l0.008-0.017c0.199-0.393,0.679-0.551,1.073-0.352 C2121.405,957.562,2121.563,958.042,2121.364,958.435L2121.364,958.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2116.727,967.333l-2.47,4.366c-0.216,0.382-0.702,0.517-1.084,0.301s-0.517-0.702-0.301-1.084 l0.009-0.016l2.451-4.335l0.009-0.016c0.216-0.383,0.702-0.518,1.085-0.301S2116.943,966.95,2116.727,967.333L2116.727,967.333z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2111.688,976.008l-2.663,4.247c-0.233,0.371-0.723,0.483-1.094,0.25 c-0.371-0.233-0.484-0.723-0.251-1.094l0.009-0.015l2.643-4.217l0.01-0.015c0.233-0.372,0.723-0.484,1.095-0.252 C2111.808,975.146,2111.92,975.636,2111.688,976.008L2111.688,976.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2106.267,984.441l-2.849,4.125c-0.249,0.36-0.742,0.45-1.102,0.202 c-0.36-0.249-0.45-0.742-0.202-1.102l0.01-0.014l2.828-4.098l0.01-0.014c0.249-0.361,0.742-0.451,1.103-0.203 C2106.425,983.587,2106.516,984.081,2106.267,984.441L2106.267,984.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2100.481,992.629l-3.024,3.999c-0.263,0.348-0.759,0.416-1.107,0.153 c-0.348-0.263-0.417-0.759-0.154-1.107l0.01-0.013l3.002-3.973l0.01-0.014c0.263-0.348,0.76-0.417,1.108-0.154 C2100.675,991.784,2100.744,992.28,2100.481,992.629L2100.481,992.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2094.349,1000.562l-3.189,3.868c-0.277,0.336-0.774,0.384-1.11,0.107 c-0.336-0.277-0.384-0.774-0.107-1.11l0.01-0.012l3.167-3.844l0.01-0.013c0.277-0.336,0.775-0.384,1.111-0.107 C2094.578,999.727,2094.626,1000.225,2094.349,1000.562L2094.349,1000.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2087.892,1008.232l-3.343,3.735c-0.29,0.324-0.787,0.352-1.111,0.062 c-0.324-0.29-0.351-0.787-0.062-1.111l0.01-0.011l3.321-3.713l0.01-0.012c0.29-0.324,0.788-0.352,1.112-0.062 C2088.155,1007.41,2088.182,1007.908,2087.892,1008.232L2087.892,1008.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2081.132,1015.637l-3.487,3.602c-0.302,0.311-0.799,0.319-1.11,0.018 c-0.312-0.301-0.32-0.798-0.018-1.11l0.01-0.011l3.465-3.581l0.01-0.011c0.302-0.312,0.799-0.32,1.111-0.018 C2081.426,1014.827,2081.434,1015.325,2081.132,1015.637L2081.132,1015.637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2074.09,1022.773l-3.621,3.468c-0.312,0.299-0.808,0.289-1.107-0.024 c-0.299-0.313-0.289-0.808,0.024-1.107l0.01-0.01l3.598-3.449l0.01-0.01c0.313-0.299,0.809-0.289,1.109,0.024 C2074.413,1021.977,2074.403,1022.473,2074.09,1022.773L2074.09,1022.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2066.786,1029.641l-3.743,3.334c-0.322,0.287-0.816,0.258-1.103-0.064s-0.259-0.816,0.064-1.103 l0.01-0.009l3.721-3.317l0.01-0.009c0.323-0.287,0.817-0.259,1.104,0.064 C2067.138,1028.859,2067.109,1029.354,2066.786,1029.641L2066.786,1029.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2059.242,1036.243l-3.854,3.199c-0.331,0.275-0.823,0.229-1.098-0.102 c-0.275-0.331-0.229-0.823,0.102-1.098l0.01-0.008l3.832-3.184l0.01-0.008c0.332-0.275,0.824-0.23,1.099,0.102 S2059.573,1035.967,2059.242,1036.243L2059.242,1036.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2051.481,1042.576l-3.958,3.07c-0.34,0.263-0.828,0.201-1.092-0.138s-0.202-0.828,0.138-1.092 l0.01-0.007l3.937-3.056l0.01-0.008c0.34-0.264,0.829-0.202,1.093,0.138C2051.883,1041.823,2051.821,1042.312,2051.481,1042.576 L2051.481,1042.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2043.515,1048.652l-4.054,2.942c-0.347,0.252-0.832,0.175-1.084-0.172 c-0.252-0.347-0.175-0.833,0.172-1.084l0.01-0.007l4.033-2.93l0.01-0.007c0.347-0.252,0.833-0.175,1.086,0.172 C2043.94,1047.913,2043.863,1048.399,2043.515,1048.652L2043.515,1048.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2035.363,1054.475l-4.141,2.819c-0.354,0.241-0.835,0.149-1.076-0.205 c-0.241-0.354-0.149-0.835,0.204-1.076l0.009-0.006l4.121-2.807l0.01-0.006c0.354-0.241,0.836-0.149,1.077,0.204 C2035.808,1053.751,2035.717,1054.233,2035.363,1054.475L2035.363,1054.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2027.039,1060.051l-4.221,2.698c-0.36,0.23-0.837,0.125-1.067-0.235 c-0.23-0.36-0.125-0.837,0.235-1.067l0.009-0.006l4.202-2.687l0.009-0.006c0.36-0.23,0.838-0.125,1.069,0.235 C2027.505,1059.342,2027.4,1059.821,2027.039,1060.051L2027.039,1060.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2018.56,1065.387l-4.294,2.58c-0.365,0.219-0.839,0.102-1.058-0.264s-0.101-0.839,0.264-1.058 l0.009-0.005l4.275-2.571l0.009-0.005c0.365-0.22,0.84-0.102,1.059,0.264C2019.044,1064.693,2018.926,1065.167,2018.56,1065.387 L2018.56,1065.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2009.938,1070.49l-4.36,2.466c-0.37,0.209-0.839,0.079-1.048-0.291 c-0.209-0.37-0.079-0.839,0.291-1.048l0.008-0.005l4.342-2.458l0.009-0.005c0.37-0.209,0.84-0.079,1.05,0.291 C2010.439,1069.811,2010.309,1070.28,2009.938,1070.49L2009.938,1070.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2001.188,1075.368l-4.417,2.354c-0.374,0.199-0.839,0.058-1.038-0.316 c-0.199-0.374-0.058-0.839,0.316-1.039l0.008-0.004l4.399-2.347l0.008-0.005c0.374-0.2,0.84-0.058,1.04,0.316 C2001.704,1074.702,2001.562,1075.167,2001.188,1075.368L2001.188,1075.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1992.326,1080.023l-4.472,2.249c-0.378,0.19-0.838,0.038-1.028-0.34 c-0.19-0.378-0.038-0.838,0.34-1.028l0.008-0.004l4.456-2.242l0.008-0.004c0.378-0.19,0.839-0.038,1.03,0.34 S1992.704,1079.833,1992.326,1080.023L1992.326,1080.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1983.355,1084.47l-4.523,2.147c-0.381,0.181-0.837,0.019-1.018-0.363 c-0.181-0.381-0.019-0.837,0.363-1.018l0.007-0.003l4.507-2.141l0.008-0.003c0.382-0.182,0.838-0.019,1.019,0.362 C1983.899,1083.832,1983.737,1084.288,1983.355,1084.47L1983.355,1084.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1974.286,1088.714l-4.569,2.048c-0.384,0.172-0.835,0-1.008-0.384 c-0.172-0.384,0-0.835,0.384-1.007l0.007-0.003l4.553-2.043l0.007-0.003c0.385-0.173,0.836-0.001,1.009,0.384 C1974.842,1088.089,1974.671,1088.541,1974.286,1088.714L1974.286,1088.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1965.127,1092.763l-4.61,1.954c-0.387,0.164-0.833-0.017-0.997-0.403 c-0.164-0.387,0.017-0.833,0.404-0.997l0.007-0.003l4.595-1.949l0.007-0.003c0.387-0.165,0.834,0.016,0.998,0.403 S1965.514,1092.599,1965.127,1092.763L1965.127,1092.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1955.887,1096.624l-4.648,1.862c-0.389,0.156-0.831-0.033-0.987-0.422 c-0.156-0.389,0.033-0.831,0.422-0.986l0.006-0.003l4.634-1.858l0.007-0.003c0.39-0.156,0.832,0.033,0.988,0.422 C1956.466,1096.025,1956.277,1096.467,1955.887,1096.624L1955.887,1096.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1946.574,1100.304l-4.679,1.772c-0.391,0.148-0.828-0.048-0.976-0.439s0.049-0.828,0.44-0.976 l0.006-0.002l4.665-1.77l0.006-0.002c0.391-0.149,0.829,0.048,0.978,0.439 C1947.162,1099.717,1946.965,1100.155,1946.574,1100.304L1946.574,1100.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1937.199,1103.807l-4.712,1.689c-0.393,0.141-0.825-0.063-0.966-0.456 c-0.141-0.393,0.063-0.825,0.456-0.966l0.006-0.002l4.699-1.686l0.006-0.002c0.393-0.141,0.826,0.063,0.967,0.457 S1937.593,1103.666,1937.199,1103.807L1937.199,1103.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1927.761,1107.144l-4.741,1.608c-0.394,0.133-0.822-0.078-0.956-0.472 c-0.134-0.395,0.078-0.822,0.472-0.956l0.006-0.002l4.728-1.605l0.006-0.002c0.395-0.134,0.823,0.077,0.957,0.472 S1928.156,1107.01,1927.761,1107.144L1927.761,1107.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1724.853,211.087 1730.989,247.648 1703.589,236.086  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1556.921,217.695l113.272,70.035c2.169,1.341,4.79,1.741,7.26,1.109 c2.47-0.632,4.577-2.242,5.835-4.46l66.032-116.376c0.756-1.332,0.628-2.99-0.323-4.191c-0.951-1.201-2.536-1.705-4.006-1.273 L1556.921,217.695z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1724.842,211.093 1556.921,217.695 1714.243,229.908 1716.377,239.974  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1707.875,241.015 1730.989,247.648 1714.243,229.908  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1855.749,1502.766c2.339,0,4.234-1.896,4.234-4.234V992.436c0-2.339-1.896-4.234-4.234-4.234 c-2.339,0-4.234,1.895-4.234,4.234v506.096C1851.515,1500.871,1853.411,1502.766,1855.749,1502.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1970.49,1502.766c2.339,0,4.234-1.896,4.234-4.234V992.436c0-2.339-1.895-4.234-4.234-4.234 c-2.338,0-4.234,1.895-4.234,4.234v506.096C1966.256,1500.871,1968.151,1502.766,1970.49,1502.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2252.393,1505.977c0.553,0,1.114-0.109,1.655-0.339c2.152-0.914,3.155-3.4,2.24-5.554 L2039.77,990.779c-0.915-2.152-3.404-3.153-5.553-2.24c-2.152,0.915-3.155,3.401-2.24,5.554l216.518,509.305 C2249.18,1505.009,2250.746,1505.977,2252.393,1505.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2118.652,1505.977c0.553,0,1.114-0.109,1.655-0.339c2.152-0.914,3.155-3.4,2.24-5.554 l-216.518-509.304c-0.915-2.152-3.404-3.153-5.553-2.24c-2.152,0.915-3.155,3.401-2.24,5.554l216.518,509.305 C2115.438,1505.009,2117.005,1505.977,2118.652,1505.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1849.176,997.094h198.336c3.296,0,5.968-2.672,5.968-5.967l0,0c0-3.296-2.672-5.968-5.968-5.968 h-198.336c-3.296,0-5.968,2.672-5.968,5.968l0,0C1843.208,994.422,1845.88,997.094,1849.176,997.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1934.843,1074.547h134.137c2.339,0,4.234-1.895,4.234-4.234c0-2.339-1.895-4.234-4.234-4.234 h-134.137c-2.339,0-4.234,1.895-4.234,4.234C1930.609,1072.652,1932.504,1074.547,1934.843,1074.547z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1976.001,
    y: 1162.401,
    style: {
      fill: "#7D97F4"
    },
    width: 134.137,
    height: 8.468
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2015.845,
    y: 1258.724,
    style: {
      fill: "#7D97F4"
    },
    width: 134.137,
    height: 8.468
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2057.63,1363.515h134.137c2.338,0,4.234-1.895,4.234-4.234s-1.895-4.234-4.234-4.234H2057.63 c-2.338,0-4.234,1.895-4.234,4.234S2055.291,1363.515,2057.63,1363.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2098.028,1459.839h134.137c2.338,0,4.234-1.895,4.234-4.234c0-2.339-1.896-4.234-4.234-4.234 h-134.137c-2.339,0-4.234,1.895-4.234,4.234C2093.793,1457.943,2095.689,1459.839,2098.028,1459.839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164487643565252591440000006052761260616617858_",
    gradientUnits: "userSpaceOnUse",
    x1: 1895.8635,
    y1: 920.4999,
    x2: 1895.8635,
    y2: 963.2499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164487643565252591440000006052761260616617858_)"
    },
    d: "M1873.206,980.513 c8.228,0.711,22.507,1.866,33.765,2.362c6.767,0.298,10.663-0.365,12.907-1.263c-0.004,0.253-0.011,0.492-0.021,0.714 c-0.053,1.185-1.016,2.132-2.212,2.199c-21.271,1.187-38.188,0.411-44.211,0.044c-1.245-0.076-1.988-1.429-1.351-2.491 C1872.401,981.547,1872.787,981.027,1873.206,980.513z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078750817489829327550000005895047905452659127_",
    gradientUnits: "userSpaceOnUse",
    x1: 1896.9413,
    y1: 975.0323,
    x2: 1902.4413,
    y2: 892.0322
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078750817489829327550000005895047905452659127_)"
    },
    d: "M1906.971,982.875 c-11.257-0.496-25.537-1.651-33.765-2.362c8.089-9.924,33.765-16.613,33.765-16.613h7.252 c4.987,7.189,5.709,14.034,5.655,17.712C1917.634,982.51,1913.737,983.173,1906.971,982.875z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034793402156551911260000002100256853592787589_",
    gradientUnits: "userSpaceOnUse",
    x1: 11500.3584,
    y1: 960.2817,
    x2: 11513.8867,
    y2: 960.2817,
    gradientTransform: "matrix(-1 0 0 1 13415.8018 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034793402156551911260000002100256853592787589_)"
    },
    d: "M1915.443,952.061l-0.678,13.429 c-0.074,1.454-1.162,2.676-2.619,2.884c-1.449,0.207-3.389,0.234-5.447-0.451c-1.266-0.422-2.206-1.488-2.439-2.789 l-2.345-13.072H1915.443z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100349038904452507900000004393349926656004536_",
    gradientUnits: "userSpaceOnUse",
    x1: 2007.964,
    y1: 939.4237,
    x2: 2006.464,
    y2: 979.6741
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100349038904452507900000004393349926656004536_)"
    },
    d: "M2009.63,982.774 c3.568-0.498,5.182-2.351,5.859-4.333c0.005,0.018,0.009,0.036,0.014,0.053c0.525,2.091-0.692,4.257-3.125,5.287 c-2.941,1.245-6.156,1.457-8.652,1.355c-2.678-0.11-5.136-1.219-6.487-2.992l-0.02-0.027 C1999.907,983.447,2003.68,983.604,2009.63,982.774z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172400007707257039330000013041374856348215952_",
    gradientUnits: "userSpaceOnUse",
    x1: 2001.6877,
    y1: 961.2474,
    x2: 1998.6877,
    y2: 885.7474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172400007707257039330000013041374856348215952_)"
    },
    d: "M1992.808,951.975h5.98 c9.109-0.186,14.829,19.027,16.702,26.467c-0.677,1.981-2.291,3.835-5.859,4.333c-5.95,0.83-9.724,0.673-12.411-0.657 c-4.921-6.476-7.361-15.961-8.534-21.496C1987.351,954.326,1992.808,951.975,1992.808,951.975z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036242934377913304610000012515641191660587953_",
    gradientUnits: "userSpaceOnUse",
    x1: 11414.3535,
    y1: 949.0041,
    x2: 11430.5215,
    y2: 949.0041,
    gradientTransform: "matrix(-1 0 0 1 13415.8018 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036242934377913304610000012515641191660587953_)"
    },
    d: "M1998.019,939.511l3.321,13.207 c0.407,1.619-0.368,3.294-1.865,4.063c-1.858,0.953-4.473,1.955-6.877,1.665c-1.13-0.136-2.069-0.932-2.443-1.997 l-4.875-13.896L1998.019,939.511z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043428917477092333000000004233158831261303977_",
    gradientUnits: "userSpaceOnUse",
    x1: 1945.7625,
    y1: 852.0251,
    x2: 2105.7622,
    y2: 733.5251
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043428917477092333000000004233158831261303977_)"
    },
    d: "M2001.98,943.329 c-4.132,3.665-17.57,4.149-17.57,4.149c-48.406-116.181-68.208-132.686-68.208-132.686 c6.99,43.852,1.127,140.934,1.127,140.934c-7.988,3.525-18.286,0-18.286,0c-0.649-71.791-11.683-134.4-24.719-183.76 c32.717-0.736,50.115-11.931,55.797-16.424C1957.392,799.509,2001.98,943.329,2001.98,943.329z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150805929503665061580000000012120888015934089_",
    gradientUnits: "userSpaceOnUse",
    x1: 6310.1255,
    y1: 7124.9854,
    x2: 6216.1255,
    y2: 7240.9854,
    gradientTransform: "matrix(-1 0 0 1 13415.8018 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150805929503665061580000000012120888015934089_)"
    },
    d: "M1921.812,621.934 c6.193,30.889,3.973,86.174,2.516,111.392c-0.41,7.088,4.538,16.914,8.537,23.617c0.627,1.051,0.24,2.398-0.849,2.957 c-6.695,3.441-29.379,14.106-55.667,15.433c-1.753,0.088-3.318-1.106-3.773-2.801 c-19.501-72.813-42.151-119.341-42.151-119.341C1855.431,613.257,1921.812,621.934,1921.812,621.934z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073709768318976562880000009800196821949601434_",
    gradientUnits: "userSpaceOnUse",
    x1: 1990.5579,
    y1: 714.5786,
    x2: 1944.5577,
    y2: 761.0788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073709768318976562880000009800196821949601434_)"
    },
    d: "M1912.899,812.041 c0.275,0,0.553-0.074,0.806-0.227c0.731-0.447,0.962-1.399,0.518-2.129c-0.26-0.428-6.522-10.549-19.193-16.663 c-0.77-0.369-1.697-0.05-2.071,0.722c-0.371,0.771-0.048,1.699,0.723,2.07c11.813,5.7,17.833,15.386,17.893,15.483 C1911.867,811.776,1912.377,812.041,1912.899,812.041z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176027928107913657170000000415926221344744095_",
    gradientUnits: "userSpaceOnUse",
    x1: 11488.4248,
    y1: 713.3398,
    x2: 11430.8711,
    y2: 764.3046,
    gradientTransform: "matrix(-1 0 0 1 13415.8018 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176027928107913657170000000415926221344744095_)"
    },
    d: "M1960.655,710.584 c-1.989,14.39-7.866,30.085-19.623,46.757l-4.469-3.643c0,0,5.159-20.932,2.226-44.687 C1946.041,707.596,1954.606,709.055,1960.655,710.584z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124134535485341424830000014411120102149166258_",
    gradientUnits: "userSpaceOnUse",
    x1: 6273.5854,
    y1: 7095.3726,
    x2: 6179.5854,
    y2: 7211.3726,
    gradientTransform: "matrix(-1 0 0 1 13415.8018 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124134535485341424830000014411120102149166258_)"
    },
    d: "M1914.895,660.047l6.917-38.113 c0,0,46.214,35.325,38.843,88.651c-6.048-1.53-14.613-2.988-21.865-1.573C1936.676,691.899,1930.365,673.321,1914.895,660.047 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031917139250156003450000004899025339249666978_",
    gradientUnits: "userSpaceOnUse",
    x1: 6350.5239,
    y1: 7157.7158,
    x2: 6256.5244,
    y2: 7273.7153,
    gradientTransform: "matrix(-1 0 0 1 13415.8018 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031917139250156003450000004899025339249666978_)"
    },
    d: "M1830.425,653.19l17.838,38.418 c-2.884,23.194-15.344,33.223-28.779,37.069c-0.838-10.571-3.51-19.111-5.991-25.018 C1830.659,685.936,1830.425,653.19,1830.425,653.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039102116237456867280000011713317504593413008_",
    gradientUnits: "userSpaceOnUse",
    x1: 11596.3174,
    y1: 718.1604,
    x2: 11641.6436,
    y2: 718.1604,
    gradientTransform: "matrix(-1 0 0 1 13415.8018 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039102116237456867280000011713317504593413008_)"
    },
    d: "M1813.493,703.659 c2.48,5.907,5.153,14.447,5.991,25.018c-35.843,13.907-45.326-13.064-45.326-13.064l6.624-1.169 C1795.741,716.022,1806.191,711.199,1813.493,703.659z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008869359691199423280000000335342703358886330_",
    gradientUnits: "userSpaceOnUse",
    x1: 11552.2588,
    y1: 597.0322,
    x2: 11551.7637,
    y2: 681.6757,
    gradientTransform: "matrix(-1 0 0 1 13415.8018 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008869359691199423280000000335342703358886330_)"
    },
    d: "M1846.86,605.761l8.612,31.658 c0.968,3.556,4.814,5.466,8.237,4.098c3.693-1.477,8.379-3.492,12.412-5.67c4.306-2.325,5.653-7.863,2.927-11.927 l-17.905-26.697L1846.86,605.761z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013915318621604094240000014426024591831722379_",
    gradientUnits: "userSpaceOnUse",
    x1: 11426.2754,
    y1: 751.3637,
    x2: 11663.6289,
    y2: 751.3637,
    gradientTransform: "matrix(-1 0 0 1 13415.8018 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013915318621604094240000014426024591831722379_)"
    },
    d: "M1757.73,694.429l220.672,80.316 c9.255,3.368,13.679,13.907,9.602,22.872l-0.67,1.472c-3.608,7.932-12.983,11.412-20.892,7.753l-214.27-99.122L1757.73,694.429z "
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.15,
      fill: "#FFFFFF"
    },
    cx: 1656.3,
    cy: 646.117,
    rx: 108.934,
    ry: 106.969
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096759017542454891110000005018351089521505941_",
    gradientUnits: "userSpaceOnUse",
    x1: 11638.2861,
    y1: 646.1167,
    x2: 11880.7158,
    y2: 646.1167,
    gradientTransform: "matrix(-1 0 0 1 13415.8018 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096759017542454891110000005018351089521505941_)"
    },
    d: "M1535.086,646.117 c0,65.738,54.27,119.028,121.215,119.028c66.945,0,121.214-53.29,121.214-119.028c0-65.737-54.27-119.028-121.214-119.028 C1589.355,527.089,1535.086,580.38,1535.086,646.117z M1552.891,646.117c0-56.081,46.297-101.543,103.409-101.543 c57.111,0,103.408,45.463,103.408,101.543c0,56.081-46.297,101.543-103.408,101.543 C1599.189,747.66,1552.891,702.198,1552.891,646.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1768.299,660.548c-0.021,0-0.042-0.001-0.064-0.004c-0.274-0.035-0.467-0.285-0.433-0.56 c0.355-2.779,0.606-5.617,0.745-8.433c0.014-0.276,0.233-0.515,0.524-0.475c0.275,0.014,0.488,0.248,0.475,0.523 c-0.141,2.842-0.394,5.705-0.752,8.511C1768.762,660.363,1768.547,660.548,1768.299,660.548z M1767.466,627.265 c-0.238,0-0.448-0.17-0.492-0.412c-1.355-7.559-3.528-14.998-6.46-22.111l-0.001-0.003 c-17.27-41.894-58.176-68.967-104.213-68.967c-21.468,0-42.337,5.964-60.353,17.246c-0.233,0.146-0.542,0.076-0.689-0.158 c-0.146-0.234-0.076-0.543,0.158-0.689c18.175-11.382,39.228-17.398,60.884-17.398c46.443,0,87.712,27.315,105.139,69.589 c0,0,0,0.002,0.001,0.003c2.958,7.178,5.152,14.686,6.519,22.314c0.049,0.271-0.132,0.531-0.404,0.58 C1767.525,627.262,1767.496,627.265,1767.466,627.265z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069357369962798401090000006864596550572923557_",
    gradientUnits: "userSpaceOnUse",
    x1: 11511.1533,
    y1: 739.006,
    x2: 11453.5996,
    y2: 789.9712,
    gradientTransform: "matrix(-1 0 0 1 13415.8018 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069357369962798401090000006864596550572923557_)"
    },
    d: "M1938.406,753.064l-20.861-1.7 l-9.034,8.328c0,0,2.137,2.955,8.82,1.256c6.682-1.698,15.835-2.115,15.835-2.115s9.225,4.159,9.337-3.623L1938.406,753.064z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066491663471308705640000003273819273738474132_",
    gradientUnits: "userSpaceOnUse",
    x1: 1807.1313,
    y1: 670.9571,
    x2: 1790.6312,
    y2: 690.4571
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066491663471308705640000003273819273738474132_)"
    },
    d: "M1776.815,720.549 c-1.804,1.409-7.985-1.533-11.767-3.568c-1.843-0.992-2.736-3.147-2.104-5.142c0.91-2.871,2.427-6.576,4.296-7.043 C1770.34,704.021,1784.25,714.74,1776.815,720.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1974.049,803.441c-0.208,0-0.401-0.13-0.473-0.337c-0.09-0.261,0.048-0.545,0.309-0.636 c6.361-2.199,9.693-5.777,9.904-10.636c0.213-4.914-2.892-9.482-7.725-11.368l-26.496-10.331 c-0.257-0.101-0.384-0.391-0.284-0.647c0.1-0.257,0.391-0.384,0.647-0.284l26.496,10.331c5.232,2.041,8.592,7.001,8.361,12.343 c-0.231,5.31-3.789,9.191-10.576,11.538C1974.159,803.433,1974.104,803.441,1974.049,803.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1941.586,766.983c-0.061,0-0.122-0.011-0.182-0.034l-3.434-1.339 c-0.257-0.101-0.384-0.391-0.284-0.648c0.101-0.257,0.392-0.386,0.647-0.284l3.434,1.339c0.257,0.101,0.384,0.391,0.284,0.647 C1941.975,766.862,1941.786,766.983,1941.586,766.983z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106128951280235849540000015638500358687628979_",
    gradientUnits: "userSpaceOnUse",
    x1: 7396.771,
    y1: 4750.3369,
    x2: 7417.271,
    y2: 4703.8369,
    gradientTransform: "matrix(-1 0 0 1 11082.8018 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106128951280235849540000015638500358687628979_)"
    },
    d: "M1844.999,574.682 c0,0-7.128,16.374-7.607,24.969c-0.479,8.594-2.331,14.171,7.607,15.902c9.937,1.731,18.309-3.22,22.844-11.781 c0,0,7.106-13.191,5.512-18.594C1871.761,579.775,1844.999,574.682,1844.999,574.682z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174594406127217333750000011548467301635877815_",
    gradientUnits: "userSpaceOnUse",
    x1: 1835.7633,
    y1: 581.7638,
    x2: 1886.3767,
    y2: 581.7638
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174594406127217333750000011548467301635877815_)"
    },
    d: "M1864.447,597.616h-1.256 c0,0,5.176-10.617,0.628-12.482c-4.548-1.865-22.564-5.539-26.451-11.932c-3.747-6.163-0.405-14.123,4.595-16.351 c0.316-0.141,0.689,0.008,0.851,0.314l0.414,0.784c0.284,0.537,1.077,0.455,1.245-0.128l0,0c0.16-0.553,0.906-0.674,1.21-0.185 c1.19,1.912,4.412,5.02,13.053,6.615c12.261,2.263,20.367,7.225,20.567,15.699c0.012,0.537,0.586,0.833,1.045,0.554 c0.905-0.552,2.354-0.81,4.29,0.817c3.367,2.831,1.989,10.175-5.391,16.215c-0.351,0.287-0.348,0.835,0.032,1.082 c1.338,0.871,3.332,2.944-1.836,5.706c-5.287,2.826-8.415,2.518-9.596,2.216c-0.318-0.081-0.531-0.371-0.511-0.698l0.464-7.509 c0.024-0.388-0.285-0.717-0.674-0.717H1864.447z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000909508005679024830000017248068963227129493_",
    gradientUnits: "userSpaceOnUse",
    x1: 7385.5015,
    y1: 4745.3589,
    x2: 7406.0015,
    y2: 4698.8589,
    gradientTransform: "matrix(-1 0 0 1 11082.8018 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000909508005679024830000017248068963227129493_)"
    },
    d: "M1864.139,599.187 c0,0,2.719-10.459,7.409-7.527c4.689,2.933-2.434,11.72-6.204,12.111L1864.139,599.187z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1447.298,476.768h-66.172c-5.061,0-9.163-4.103-9.163-9.163v-66.35 c0-4.774,3.666-8.748,8.424-9.134l70.502-5.706c5.554-0.45,10.22,4.121,9.886,9.683l-4.33,72.056 C1456.154,472.993,1452.146,476.768,1447.298,476.768z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163045901115013282230000012291332528993919139_",
    gradientUnits: "userSpaceOnUse",
    x1: 1383.5474,
    y1: 434.4628,
    x2: 1447.9745,
    y2: 434.4628
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163045901115013282230000012291332528993919139_)"
    },
    d: "M1390.559,463.854 c-1.777,0-3.509-0.682-4.808-1.906c-1.4-1.319-2.203-3.178-2.203-5.101v-42.539c0-1.2,0.973-2.173,2.172-2.173 c1.2,0,2.172,0.973,2.172,2.173v42.539c0,0.742,0.297,1.43,0.837,1.938c0.539,0.508,1.245,0.76,1.984,0.72l50.411-3.001 c1.404-0.085,2.505-1.253,2.505-2.659v-41.766c0-0.762-0.311-1.462-0.875-1.973c-0.564-0.512-1.295-0.756-2.051-0.677 l-41.934,4.153c-1.385,0.137-1.976,1.136-2.167,1.558c-0.19,0.423-0.544,1.529,0.272,2.655l15.993,22.072 c0.502,0.693,1.28,1.094,2.135,1.101c0.007,0,0.016,0,0.023,0c0.845,0,1.621-0.387,2.129-1.065l17.617-23.472 c0.719-0.958,2.081-1.155,3.041-0.434c0.96,0.72,1.154,2.082,0.434,3.041l-17.617,23.473c-1.351,1.799-3.373,2.851-5.663,2.801 c-2.25-0.019-4.297-1.075-5.617-2.896l-15.993-22.072c-1.491-2.057-1.76-4.669-0.718-6.986c1.042-2.318,3.174-3.85,5.702-4.101 l41.933-4.153c1.969-0.191,3.933,0.454,5.397,1.78c1.464,1.326,2.303,3.218,2.303,5.194v41.766c0,3.702-2.895,6.775-6.592,6.996 l-50.41,3.001C1390.835,463.849,1390.696,463.854,1390.559,463.854z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomweb);
export default __webpack_public_path__ + "static/media/custom web.01c6451e826f47da5de8453fad7b4dd7.svg";
export { ForwardRef as ReactComponent };